{
  "lv": {
    "brand": {
      "name": "kreditiem.lv | Apdrošināšana",
      "legal_name": "AS Baltijas investīciju un attīstības fonds",
      "tagline": "Apdrošināšana sadarbībā ar Balcia Insurance",
      "broker_label": "Balcia Insurance partneris",
      "description": "Apdrošināšana sadarbībā ar Balcia Insurance. Palīdzam izvēlēties un noformēt piemērotu risinājumu privātpersonām un uzņēmumiem.",
      "email": "info@kreditiem.lv",
      "phone": "+371 20865183",
      "phone_e164": "+37120865183",
      "working_hours": "Pirmdiena - Piektdiena: 8:00 - 18:00",
      "address": "Bukultu iela 11, Rīga, Latvija",
      "street_address": "Bukultu iela 11",
      "postal_code": "LV-1024",
      "address_locality": "Rīga",
      "address_country": "LV",
      "registration_number": 40003000000,
      "opening_hours": "Mo-Fr 08:00-18:00"
    },
    "form": {
      "other_slug": "other",
      "other_label": "Cits",
      "insurance_types": {
        "octa": "OCTA",
        "kasko": "KASKO",
        "home": "Mājokļa",
        "travel": "Ceļojumu",
        "health": "Veselības",
        "accident": "Nelaimes gadījumu",
        "liability": "Civiltiesiskā",
        "employee": "Darbinieku",
        "commercial_real_estate": "Komercīpašuma",
        "Freight": "Kravu",
        "company": "Uzņēmumu",
        "other": "Cits"
      }
    },
    "breadcrumbs": {
      "home": "Sākums",
      "blog": "Blogs",
      "private_persons": "Privātpersonām",
      "businesses": "Uzņēmumiem"
    },
    "cookie_consent": {
      "accept": "Pieņemt visus",
      "decline": "Noraidīt",
      "message": "Mēs izmantojam sīkfailus, lai uzlabotu jūsu pārlūkošanas pieredzi, sniegtu personalizētu saturu un analizētu mūsu klientu plūsmu. Noklikšķinot uz \"Pieņemt visus\", jūs piekrītat mūsu sīkfailu izmantošanai.",
      "privacy_policy": "Izlasi mūsu Privātuma politiku",
      "settings": "Sīkfailu iestatījumi"
    },
    "insurance_products": {
      "show": {
        "private_breadcrumb": "Privātpersonām",
        "business_breadcrumb": "Uzņēmumiem"
      }
    },
    "meta": {
      "home": {
        "title": "%{brand} — %{tagline}",
        "description": "%{description}"
      },
      "private_persons": {
        "title": "Apdrošināšana privātpersonām — OCTA, KASKO, mājoklis, ceļojumi | %{brand}",
        "description": "Apdrošināšanas piedāvājums privātpersonām: OCTA, KASKO, mājokļa, ceļojumu, veselības un nelaimes gadījumu apdrošināšana."
      },
      "businesses": {
        "title": "Apdrošināšana uzņēmumiem — īpašums, atbildība, darbinieki, kravas | %{brand}",
        "description": "Apdrošināšanas risinājumi uzņēmumiem: komercīpašums, civiltiesiskā atbildība, darbinieku veselība, kravu un transporta apdrošināšana."
      },
      "blogs": {
        "title": "Blogs par apdrošināšanu — padomi un skaidrojumi | %{brand}",
        "description": "Raksti par apdrošināšanu: kā izvēlēties OCTA un KASKO, ko sedz mājokļa apdrošināšana, atlīdzību pieteikšana un padomi uzņēmumiem."
      },
      "blog_category": {
        "title": "%{name} — raksti un padomi | %{brand}"
      },
      "application": {
        "title": "Pieteikties apdrošināšanai — saņemiet piedāvājumu | %{brand}",
        "description": "Aizpildiet vienu pieteikumu un saņemiet apdrošināšanas piedāvājumu. Bezmaksas konsultācija privātpersonām un uzņēmumiem."
      },
      "contacts": {
        "title": "Kontakti — sazinieties ar apdrošināšanas konsultantu | %{brand}",
        "description": "Sazinieties ar %{brand}: %{phone}, %{email}. %{working_hours}."
      },
      "not_found": {
        "title": "Lapa nav atrasta | %{brand}",
        "description": "Diemžēl šī lapa nav atrasta. Atgriezieties sākumlapā vai sazinieties ar mums."
      }
    },
    "home": {
      "hero": {
        "title": "Saņemiet apdrošināšanas piedāvājumu",
        "subtitle": "Aizpildiet vienu pieteikumu, un mūsu apdrošināšanas konsultants sagatavos piedāvājumu. Konsultācija ir bez maksas, lēmumu pieņemat tikai jūs.",
        "highlights": [
          "Viens pieteikums — viens piedāvājums",
          "Bezmaksas konsultācija ar apdrošināšanas konsultantu",
          "Atbilde vienas darba dienas laikā"
        ],
        "stats": [
          {
            "value": "Balcia",
            "label": "Apdrošināšanas partneris"
          },
          {
            "value": "4 min",
            "label": "Vidējais pieteikuma aizpildīšanas laiks"
          },
          {
            "value": "9 000+",
            "label": "Sagatavoti piedāvājumi"
          }
        ]
      },
      "advantages": [
        {
          "icon": "layers",
          "title": "Piedāvājums vienā pieteikumā",
          "description": "Aizpildiet pieteikumu, un sagatavosim apdrošināšanas piedāvājumu, kas atbilst jūsu situācijai."
        },
        {
          "icon": "bolt",
          "title": "Ātra pieteikuma izskatīšana",
          "description": "Pieteikuma aizpildīšana aizņem dažas minūtes, un piedāvājumu parasti sagatavojam vienas darba dienas laikā."
        },
        {
          "icon": "gift",
          "title": "Bezmaksas konsultācija",
          "description": "Par konsultāciju jums nav jāmaksā. Mēs paskaidrojam noteikumus saprotamā valodā, arī tos, kas rakstīti sīkajā drukā."
        },
        {
          "icon": "user-check",
          "title": "Personīgs apdrošināšanas konsultants",
          "description": "Jums ir viens kontaktpersona — gan izvēloties polisi, gan tad, ja vēlāk nepieciešams pieteikt atlīdzību."
        }
      ],
      "steps": [
        {
          "title": "Aizpildiet pieteikumu",
          "description": "Norādiet, ko vēlaties apdrošināt, un savu kontaktinformāciju. Sarežģītos jautājumus varat atstāt mūsu konsultantam."
        },
        {
          "title": "Konsultants sagatavo piedāvājumu",
          "description": "Pārbaudām, ka segums atbilst jūsu situācijai, un sagatavojam apdrošināšanas piedāvājumu."
        },
        {
          "title": "Saņemiet piedāvājumu",
          "description": "Nosūtām piedāvājumu ar cenu un segumu. Kad esat izvēlējies, polisi noformējam attālināti."
        }
      ],
      "testimonials": [
        {
          "name": "Ilze K.",
          "role": "Rīga, mājokļa apdrošināšana",
          "quote": "Konsultants paskaidroja, kas ir iekļauts polisē. Izvēlējos piedāvājumu, kas sedza ūdens noplūdi.",
          "rating": 5
        },
        {
          "name": "Māris B.",
          "role": "Jelgava, OCTA un KASKO",
          "quote": "Iepriekš OCTA pirku pēdējā dienā un nedomājot. Šoreiz saņēmu skaidru piedāvājumu un noformēju polisi laikus.",
          "rating": 5
        },
        {
          "name": "Anete S.",
          "role": "SIA vadītāja, darbinieku apdrošināšana",
          "quote": "Vajadzēja veselības apdrošināšanu 14 darbiniekiem. Konsultants sagatavoja piedāvājumu, ko varēju parādīt valdei.",
          "rating": 5
        }
      ],
      "faq": [
        {
          "question": "Cik maksā konsultācija?",
          "answer": "Pieteikuma sagatavošana un konsultācija jums neizmaksā nekā. Konsultanta atlīdzību maksā apdrošinātājs, tāpēc polises cena jums nav augstāka par to, ko piedāvā apdrošinātājs tieši."
        },
        {
          "question": "Cik ātri saņemšu piedāvājumu?",
          "answer": "Vienkāršiem produktiem, piemēram, OCTA vai ceļojumu apdrošināšanai, piedāvājumu parasti nosūtām dažu stundu laikā darba dienā. Uzņēmumu apdrošināšanai var būt nepieciešamas divas līdz trīs darba dienas."
        },
        {
          "question": "Vai man ir jāpiekrīt piedāvājumam?",
          "answer": "Nē. Piedāvājums ir informatīvs, un jums nav pienākuma to pieņemt. Ja tas neatbilst, varam precizēt vajadzības vai pārtraukt saziņu."
        },
        {
          "question": "Kādus datus jūs uzglabājat?",
          "answer": "Uzglabājam tikai to informāciju, kas nepieciešama piedāvājuma sagatavošanai, un nododam to apdrošinātājam. Datus varat lūgt dzēst jebkurā laikā."
        },
        {
          "question": "Vai varat palīdzēt arī tad, ja notikusi apdrošināšanas gadījums?",
          "answer": "Jā. Palīdzam saprast, kādi dokumenti nepieciešami, un sazināmies ar apdrošinātāju, ja atlīdzības process ieilgst."
        },
        {
          "question": "Vai varu apdrošināt vairākas lietas vienā pieteikumā?",
          "answer": "Pieteikumā izvēlieties galveno apdrošināšanas veidu un komentāros norādiet pārējo. Konsultants sagatavos kopēju piedāvājumu, kur bieži var panākt atlaidi par vairākiem produktiem."
        }
      ],
      "sections": {
        "products": {
          "eyebrow": "Apdrošināšanas veidi",
          "title": "Izvēlieties, ko vēlaties apdrošināt",
          "subtitle": "Katram veidam ir sava lapa, kur skaidrojam segumu, izņēmumus un cenu veidošanos."
        },
        "advantages": {
          "eyebrow": "Kāpēc mēs",
          "title": "Konsultants strādā jūsu, nevis apdrošinātāja interesēs"
        },
        "steps": {
          "eyebrow": "Kā tas notiek",
          "title": "Trīs soļi līdz piedāvājumam"
        },
        "faq": {
          "eyebrow": "Biežākie jautājumi",
          "title": "Atbildes uz to, ko klienti jautā visbiežāk"
        },
        "blog": {
          "eyebrow": "Blogs",
          "title": "Noderīgi raksti par apdrošināšanu"
        }
      }
    },
    "contacts": {
      "intro": "Rakstiet vai zvaniet — atbildam darba dienās. Ja vēlaties piedāvājumu, ātrākais veids ir aizpildīt pieteikumu, jo tad uzreiz redzam nepieciešamo informāciju.",
      "channels": [
        {
          "icon": "phone",
          "label": "Telefons",
          "value": "+371 20865183",
          "href": "tel:+37120865183",
          "note": "Pirmdiena - Piektdiena: 8:00 - 18:00"
        },
        {
          "icon": "mail",
          "label": "E-pasts",
          "value": "info@kreditiem.lv",
          "href": "mailto:info@kreditiem.lv",
          "note": "Atbildam 1 darba dienas laikā"
        },
        {
          "icon": "map-pin",
          "label": "Birojs",
          "value": "Bukultu iela 11, Rīga, Latvija",
          "note": "Tikšanās iepriekš saskaņojot"
        }
      ],
      "notes": [
        {
          "title": "Pieteikumu izskatīšana",
          "description": "Pieteikumus saņemam visu diennakti, bet apstrādājam darba laikā. Steidzamos gadījumos, piemēram, ja OCTA beidzas šodien, zvaniet."
        },
        {
          "title": "Atlīdzību jautājumi",
          "description": "Ja noticis apdrošināšanas gadījums, sākumā ziņojiet apdrošinātājam un pēc tam mums — palīdzēsim ar dokumentiem un saziņu."
        }
      ],
      "page": {
        "title": "Sazinieties ar mums",
        "channels_title": "Saziņas veidi",
        "notes_title": "Noderīgi zināt",
        "details_title": "Rekvizīti",
        "name": "Nosaukums",
        "registration_number": "Reģistrācijas numurs",
        "address": "Adrese",
        "working_hours": "Darba laiks",
        "cta_title": "Vēlaties piedāvājumu bez sarunas?",
        "cta_description": "Aizpildiet pieteikumu, un atbildēsim ar apdrošināšanas piedāvājumu."
      }
    },
    "audiences": {
      "private": {
        "heading": "Apdrošināšana privātpersonām",
        "subheading": "Izvēlieties apdrošināšanas veidu un saņemiet piedāvājumu vienā pieteikumā."
      },
      "business": {
        "heading": "Apdrošināšana uzņēmumiem",
        "subheading": "No komercīpašuma līdz darbinieku veselībai — sagatavosim piedāvājumu, kas atbilst jūsu nozares riskiem."
      },
      "sections": {
        "products_private": "Apdrošināšanas veidi privātpersonām",
        "products_business": "Apdrošināšanas veidi uzņēmumiem",
        "products_subtitle": "Katrā lapā atradīsiet segumu, izņēmumus, orientējošās cenas un biežākos jautājumus.",
        "steps_title": "Kā notiek pieteikšanās",
        "advantages_title": "Ko iegūstat, strādājot ar konsultantu",
        "faq_title": "Biežākie jautājumi"
      }
    },
    "categories": {
      "auto": {
        "name": "Auto apdrošināšana",
        "description": "OCTA, KASKO un viss, kas jāzina par auto apdrošināšanu Latvijā.",
        "position": 1
      },
      "majoklis": {
        "name": "Mājokļa apdrošināšana",
        "description": "Māju, dzīvokļu un mājsaimniecības mantas apdrošināšana saprotamā valodā.",
        "position": 2
      },
      "celojumi": {
        "name": "Ceļojumu apdrošināšana",
        "description": "Ko sedz ceļojumu polise, kā rīkoties ārzemēs un kā izvēlēties segumu.",
        "position": 3
      },
      "veseliba": {
        "name": "Veselības apdrošināšana",
        "description": "Veselības un nelaimes gadījumu apdrošināšana privātpersonām un ģimenēm.",
        "position": 4
      },
      "uznemumiem": {
        "name": "Uzņēmumu apdrošināšana",
        "description": "Risku pārvaldība uzņēmumiem: īpašums, pārtraukumi, darbinieki un kravas.",
        "position": 5
      },
      "atbildiba": {
        "name": "Civiltiesiskā atbildība",
        "description": "Kad atbildības apdrošināšana ir obligāta un kad tā vienkārši ir prātīga.",
        "position": 6
      },
      "atlidzibas": {
        "name": "Atlīdzības",
        "description": "Kā pieteikt atlīdzību, kādi dokumenti vajadzīgi un kāpēc to atsaka.",
        "position": 7
      },
      "padomi": {
        "name": "Apdrošināšanas padomi",
        "description": "Praktiski padomi, kā izvēlēties segumu un nemaksāt par lieko.",
        "position": 8
      }
    },
    "category_order": [
      "auto",
      "majoklis",
      "celojumi",
      "veseliba",
      "uznemumiem",
      "atbildiba",
      "atlidzibas",
      "padomi"
    ],
    "product_order": [
      "octa",
      "kasko",
      "majokla-apdrosinasana",
      "celojumu-apdrosinasana",
      "veselibas-apdrosinasana",
      "nelaimes-gadijumu-apdrosinasana",
      "civiltiesiska-atbildiba",
      "darbinieku-apdrosinasana",
      "komercipasuma-apdrosinasana",
      "kravu-apdrosinasana",
      "uznemumu-apdrosinasana"
    ],
    "blog_order": [
      "pasrisks-ka-izveleties",
      "ka-ietaupit-uz-apdrosinasanu",
      "kapec-atsaka-atlidzibu",
      "ka-pieteikt-atlidzibu",
      "kravu-apdrosinasana-vai-pietiek-ar-parvadataju",
      "komercipasuma-apdrosinasana-noliktavai",
      "uznemuma-apdrosinasana-ar-ko-sakt",
      "profesionala-atbildiba-pakalpojumiem",
      "civiltiesiska-atbildiba-uznemumiem",
      "nelaimes-gadijumu-apdrosinasana-berniem",
      "veselibas-polise-ko-tiesi-sedz",
      "veselibas-apdrosinasana-darbiniekiem",
      "celojumu-apdrosinasana-ziemas-sportam",
      "evak-karte-vai-celojumu-polise",
      "celojumu-apdrosinasana-eiropa",
      "ka-noteikt-apdrosinajuma-summu",
      "udens-noplude-dzivokli",
      "ko-sedz-majokla-apdrosinasana",
      "bonus-malus-sistema",
      "kasko-vai-octa",
      "ka-izveleties-octa"
    ],
    "page_order": [
      "lietosanas-noteikumi",
      "privatuma-politika",
      "sikdatnu-politika"
    ],
    "pages": {
      "lietosanas-noteikumi": {
        "title": "Lietošanas noteikumi",
        "subtitle": "Noteikumi, kas attiecas uz mājaslapas izmantošanu un apdrošināšanas pieteikuma iesniegšanu.",
        "updated_on": "2026-08-01",
        "seo": {
          "title": "Lietošanas noteikumi | kreditiem.lv Apdrošināšana",
          "description": "kreditiem.lv Apdrošināšana mājaslapas lietošanas noteikumi: pakalpojuma apraksts, pieteikuma iesniegšana, informācijas precizitāte un atbildības ierobežojumi."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Izmantojot šo mājaslapu un iesniedzot apdrošināšanas pieteikumu, jūs piekrītat šiem noteikumiem. Lūdzam tos izlasīt pirms pieteikuma nosūtīšanas."
          },
          {
            "type": "heading",
            "text": "Par pakalpojumu"
          },
          {
            "type": "paragraph",
            "text": "kreditiem.lv Apdrošināšana darbojas kā apdrošināšanas starpnieks. Mēs nesniedzam apdrošināšanas pakalpojumu paši un neuzņemamies apdrošināšanas risku. Apdrošināšanas līgums vienmēr tiek noslēgts starp jums un apdrošināšanas sabiedrību."
          },
          {
            "type": "heading",
            "text": "Pieteikuma iesniegšana"
          },
          {
            "type": "list",
            "items": [
              "Pieteikuma iesniegšana ir bez maksas un neuzliek pienākumu iegādāties polisi",
              "Pieteikums nav apdrošināšanas līgums un nenodrošina apdrošināšanas segumu",
              "Segums sākas tikai pēc polises noformēšanas un prēmijas apmaksas",
              "Piedāvājums ir spēkā tajā norādīto termiņu"
            ]
          },
          {
            "type": "heading",
            "text": "Informācijas precizitāte"
          },
          {
            "type": "paragraph",
            "text": "Piedāvājuma aprēķins balstās uz jūsu sniegtajiem datiem. Ja dati ir nepilnīgi vai neprecīzi, galīgā cena un seguma nosacījumi var atšķirties. Būtiskas informācijas neuzrādīšana var būt pamats apdrošinātāja atteikumam izmaksāt atlīdzību."
          },
          {
            "type": "heading",
            "text": "Mājaslapas saturs"
          },
          {
            "type": "paragraph",
            "text": "Rakstos un produktu aprakstos sniegtā informācija ir vispārīga un informatīva. Tā neaizstāj apdrošināšanas līguma noteikumus. Konkrētā seguma apjomu vienmēr nosaka polise un tās noteikumi, ko saņemat pirms iegādes."
          },
          {
            "type": "callout",
            "title": "Cenu piemēri ir orientējoši",
            "text": "Mājaslapā norādītie cenu diapazoni ir orientējoši un balstīti uz tipiskiem gadījumiem. Jūsu cenu nosaka apdrošinātājs pēc individuāla aprēķina."
          },
          {
            "type": "heading",
            "text": "Atbildības ierobežojumi"
          },
          {
            "type": "paragraph",
            "text": "Mēs cenšamies nodrošināt, lai informācija mājaslapā būtu aktuāla un pareiza, taču neuzņemamies atbildību par zaudējumiem, kas radušies, paļaujoties tikai uz vispārīgo informāciju bez konsultācijas. Neatbildam arī par apdrošinātāja lēmumiem par atlīdzības izmaksu."
          },
          {
            "type": "heading",
            "text": "Intelektuālais īpašums"
          },
          {
            "type": "paragraph",
            "text": "Mājaslapas saturs, tostarp raksti un apraksti, pieder kreditiem.lv Apdrošināšana. Saturu drīkst citēt, norādot avotu, bet ne pārpublicēt pilnībā bez rakstiskas atļaujas."
          },
          {
            "type": "heading",
            "text": "Sūdzības un strīdi"
          },
          {
            "type": "paragraph",
            "text": "Ja neesat apmierināts ar mūsu pakalpojumu, rakstiet uz info@kreditiem.lv. Sūdzības izskatām 15 darba dienu laikā. Ja risinājums neapmierina, varat vērsties apdrošināšanas ombudā vai Patērētāju tiesību aizsardzības centrā."
          }
        ]
      },
      "privatuma-politika": {
        "title": "Privātuma politika",
        "subtitle": "Kā mēs apstrādājam personas datus, kas iesniegti apdrošināšanas pieteikumā vai saziņā ar mums.",
        "updated_on": "2026-08-01",
        "seo": {
          "title": "Privātuma politika | kreditiem.lv Apdrošināšana",
          "description": "Informācija par personas datu apstrādi kreditiem.lv Apdrošināšana mājaslapā: apstrādes mērķi, tiesiskais pamats, saņēmēji, glabāšanas termiņi un jūsu tiesības."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Šī privātuma politika skaidro, kā kreditiem.lv Apdrošināšana apstrādā personas datus, kad aizpildāt apdrošināšanas pieteikumu, rakstāt e-pastu vai zvanāt mums. Personas datu apstrādi veicam saskaņā ar Vispārīgo datu aizsardzības regulu."
          },
          {
            "type": "heading",
            "text": "Kas ir datu pārzinis"
          },
          {
            "type": "paragraph",
            "text": "Datu pārzinis ir AS Baltijas investīciju un attīstības fonds, Bukultu iela 11, Rīga, Latvija. Jautājumos par datu apstrādi rakstiet uz info@kreditiem.lv."
          },
          {
            "type": "heading",
            "text": "Kādus datus apstrādājam"
          },
          {
            "type": "list",
            "items": [
              "Kontaktinformācija — vārds, uzvārds, tālrunis, e-pasts, pilsēta",
              "Uzņēmuma dati — nosaukums, reģistrācijas numurs, kontaktpersona, nozare",
              "Personas kods, ja to norādāt polises noformēšanai",
              "Informācija par apdrošināmo objektu — transportlīdzeklis, īpašums, ceļojums",
              "Saziņas vēsture un pieteikuma komentāri"
            ]
          },
          {
            "type": "heading",
            "text": "Apstrādes mērķi un tiesiskais pamats"
          },
          {
            "type": "list",
            "items": [
              "Apdrošināšanas piedāvājuma sagatavošana — līguma sagatavošana pēc jūsu pieprasījuma",
              "Saziņa par pieteikumu — līguma sagatavošana un mūsu leģitīmās intereses",
              "Komerciālu paziņojumu sūtīšana — tikai ar jūsu atsevišķu piekrišanu",
              "Grāmatvedības un normatīvo prasību izpilde — juridisks pienākums"
            ]
          },
          {
            "type": "heading",
            "text": "Kam datus nododam"
          },
          {
            "type": "paragraph",
            "text": "Lai sagatavotu piedāvājumu, nepieciešamos datus nododam apdrošināšanas sabiedrībām, no kurām pieprasām cenas. Papildus izmantojam pakalpojumu sniedzējus klientu attiecību pārvaldībai un e-pasta sūtīšanai, kas darbojas kā datu apstrādātāji uz līguma pamata."
          },
          {
            "type": "heading",
            "text": "Cik ilgi datus glabājam"
          },
          {
            "type": "list",
            "items": [
              "Pieteikumus, kas nav noslēgušies ar polisi — līdz 2 gadiem",
              "Datus par noformētām polisēm — atbilstoši normatīvajos aktos noteiktajiem termiņiem",
              "Mārketinga piekrišanas — līdz piekrišanas atsaukšanai"
            ]
          },
          {
            "type": "heading",
            "text": "Jūsu tiesības"
          },
          {
            "type": "list",
            "items": [
              "Piekļūt saviem datiem un saņemt to kopiju",
              "Labot neprecīzus datus",
              "Lūgt datu dzēšanu, ja apstrādei vairs nav pamata",
              "Ierobežot apstrādi vai iebilst pret to",
              "Atsaukt piekrišanu komerciāliem paziņojumiem jebkurā laikā",
              "Iesniegt sūdzību Datu valsts inspekcijai"
            ]
          },
          {
            "type": "callout",
            "title": "Kā izmantot savas tiesības",
            "text": "Nosūtiet pieprasījumu uz info@kreditiem.lv, norādot, ko vēlaties. Atbildam viena mēneša laikā. Ja nepieciešams, varam lūgt precizēt identitāti."
          },
          {
            "type": "heading",
            "text": "Datu drošība"
          },
          {
            "type": "paragraph",
            "text": "Datus pārraida šifrēti, piekļuve tiem ir tikai darbiniekiem, kam tā nepieciešama darba pienākumu veikšanai, un sistēmas ir aizsargātas ar piekļuves kontroli. Pieteikuma formā ievadītos datus nekad nepārraidām trešajām pusēm mārketinga nolūkos."
          }
        ]
      },
      "sikdatnu-politika": {
        "title": "Sīkdatņu politika",
        "subtitle": "Kādas sīkdatnes izmantojam mājaslapā, kāpēc tās nepieciešamas un kā tās pārvaldīt.",
        "updated_on": "2026-08-01",
        "seo": {
          "title": "Sīkdatņu politika | kreditiem.lv Apdrošināšana",
          "description": "Informācija par sīkdatnēm kreditiem.lv Apdrošināšana mājaslapā: nepieciešamās sīkdatnes, to mērķis, glabāšanas termiņi un kā tās dzēst pārlūkprogrammā."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Sīkdatnes ir nelieli teksta faili, ko pārlūkprogramma saglabā jūsu ierīcē, kad apmeklējat mājaslapu. Tās palīdz nodrošināt lapas darbību un atcerēties jūsu izvēles."
          },
          {
            "type": "heading",
            "text": "Kādas sīkdatnes izmantojam"
          },
          {
            "type": "list",
            "items": [
              "Nepieciešamās sīkdatnes — sesijas identifikators un drošības marķieris, bez kura pieteikuma formu nav iespējams nosūtīt",
              "Pārlūkprogrammas sesijas glabātava (sessionStorage) — saglabā iesākto pieteikumu, lai lapas pārlādēšana neizdzēstu ievadīto informāciju"
            ]
          },
          {
            "type": "paragraph",
            "text": "Mājaslapā netiek izmantotas reklāmas vai profilēšanas sīkdatnes, un dati netiek nodoti reklāmas tīkliem."
          },
          {
            "type": "heading",
            "text": "Nepieciešamās sīkdatnes"
          },
          {
            "type": "paragraph",
            "text": "Šīs sīkdatnes ir tehniski nepieciešamas, lai mājaslapa darbotos droši. Tās nodrošina aizsardzību pret pieprasījumu viltošanu, kad nosūtāt apdrošināšanas pieteikumu. Bez tām formu nosūtīt nav iespējams, tāpēc tām nav nepieciešama atsevišķa piekrišana."
          },
          {
            "type": "heading",
            "text": "Glabāšanas termiņi"
          },
          {
            "type": "list",
            "items": [
              "Sesijas sīkdatnes tiek dzēstas, aizverot pārlūkprogrammu",
              "Iesāktais pieteikums sesijas glabātavā tiek dzēsts, kad pieteikumu nosūtāt vai aizverat cilni"
            ]
          },
          {
            "type": "heading",
            "text": "Kā pārvaldīt sīkdatnes"
          },
          {
            "type": "paragraph",
            "text": "Sīkdatnes varat dzēst vai bloķēt pārlūkprogrammas iestatījumos. Ņemiet vērā, ka, bloķējot nepieciešamās sīkdatnes, apdrošināšanas pieteikuma nosūtīšana nedarbosies. Šādā gadījumā varat pieteikties, zvanot vai rakstot mums."
          },
          {
            "type": "callout",
            "title": "Ārējie pakalpojumi",
            "text": "Mājaslapa ielādē burtveidolus no Google Fonts, kas apstrādā jūsu IP adresi tehniskai piegādei. Ja to nevēlaties, pārlūkprogrammā varat bloķēt ārējos resursus — lapas saturs paliks pieejams."
          },
          {
            "type": "heading",
            "text": "Izmaiņas politikā"
          },
          {
            "type": "paragraph",
            "text": "Ja mainīsim izmantoto sīkdatņu klāstu, atjaunināsim šo lapu un norādīsim jauno datumu. Būtisku izmaiņu gadījumā lūgsim piekrišanu atkārtoti."
          }
        ]
      }
    },
    "products": {
      "celojumu-apdrosinasana": {
        "name": "Ceļojumu apdrošināšana",
        "short_name": "Ceļojumi",
        "internal_name": "travel",
        "category": "travel",
        "audiences": [
          "private",
          "business"
        ],
        "icon": "plane",
        "position": 5,
        "tagline": "Medicīniskā palīdzība un ceļojuma riski ārzemēs",
        "summary": "Sedz neatliekamo medicīnisko palīdzību ārzemēs, bagāžas nozaudēšanu un ceļojuma atcelšanu. Vienreizēja polise vienam braucienam vai gada polise.",
        "hero": {
          "title": "Ceļojumu apdrošināšana no dažiem eiro dienā",
          "subtitle": "Eiropas veselības apdrošināšanas karte sedz tikai valsts medicīnu un ne vienmēr transportēšanu mājās. Ceļojumu polise nosedz pārējo — arī privātās klīnikas rēķinu un palīdzību pa telefonu latviešu valodā.",
          "highlights": [
            "Medicīniskie izdevumi līdz vairākiem simtiem tūkstošu eiro",
            "Bagāžas nozaudēšana un kavēti lidojumi",
            "Gada polise biežiem braucieniem"
          ]
        },
        "benefits": [
          {
            "icon": "stethoscope",
            "title": "Neatliekamā medicīniskā palīdzība",
            "description": "Ārsta apmeklējums, medikamenti, stacionārs un, ja nepieciešams, transportēšana atpakaļ uz Latviju."
          },
          {
            "icon": "luggage",
            "title": "Bagāža un dokumenti",
            "description": "Nozaudēta, aizkavēta vai bojāta bagāža, kā arī dokumentu atjaunošanas izdevumi ārzemēs."
          },
          {
            "icon": "calendar-x",
            "title": "Ceļojuma atcelšana",
            "description": "Ja brauciens jāatceļ slimības vai citu polisē norādītu iemeslu dēļ, apdrošinātājs atlīdzina neatgriežamos izdevumus."
          },
          {
            "icon": "activity",
            "title": "Sports un aktīvā atpūta",
            "description": "Slēpošanu, niršanu un citas aktivitātes sedz tikai ar atbilstošu papildu segumu — to izvēlamies atbilstoši jūsu plāniem."
          }
        ],
        "covered": [
          "Neatliekamā ārstēšana, medikamenti un stacionārs",
          "Repatriācija un tuvinieka izdevumi, ja nepieciešama pavadīšana",
          "Bagāžas nozaudēšana, aizkavēšanās vai bojājumi",
          "Ceļojuma atcelšana vai pārtraukšana pamatotu iemeslu dēļ",
          "Civiltiesiskā atbildība, ja ceļojumā nodarāt zaudējumus citiem"
        ],
        "not_covered": [
          "Hronisku slimību plānveida ārstēšana un profilaktiskās pārbaudes",
          "Traumas alkohola vai narkotisko vielu ietekmē",
          "Ekstrēmie sporta veidi bez atsevišķa seguma",
          "Grūtniecība pēc polisē norādītās nedēļas",
          "Ceļojumi uz valstīm, kur izsludināts ceļošanas aizliegums"
        ],
        "pricing": {
          "intro": "Cena ir atkarīga no ceļojuma ilguma, valsts un vecuma. Gada polise atmaksājas jau no diviem trim braucieniem gadā.",
          "examples": [
            {
              "label": "7 dienas Eiropā, viens cilvēks",
              "price": "8–18 €",
              "note": "Medicīniskais segums 100 000 €"
            },
            {
              "label": "Ģimene, 10 dienas Eiropā",
              "price": "25–50 €",
              "note": "Divi pieaugušie un divi bērni"
            },
            {
              "label": "Gada polise, neierobežoti braucieni Eiropā",
              "price": "45–90 € / gadā",
              "note": "Katrs brauciens līdz 45 dienām"
            }
          ],
          "factors": [
            "Ceļojuma galamērķis un ilgums",
            "Ceļotāju skaits un vecums",
            "Medicīniskā seguma limits",
            "Papildu riski: sports, darbs, ceļojuma atcelšana"
          ]
        },
        "faq": [
          {
            "question": "Vai pietiek ar Eiropas veselības apdrošināšanas karti?",
            "answer": "Tā dod tiesības uz valsts medicīnas pakalpojumiem tādā apmērā kā vietējiem iedzīvotājiem, bet nesedz pacienta līdzmaksājumus, privātās klīnikas vai transportēšanu uz Latviju."
          },
          {
            "question": "Vai polisi var nopirkt, jau esot ārzemēs?",
            "answer": "Dažiem apdrošinātājiem tas ir iespējams, bet parasti ar nogaidīšanas periodu. Ieteicams noformēt pirms izbraukšanas."
          },
          {
            "question": "Vai sedz slēpošanu Alpos?",
            "answer": "Tikai ar aktīvās atpūtas vai ziemas sporta segumu. Bez tā traumas nogāzē var netikt atlīdzinātas."
          },
          {
            "question": "Ko darīt, ja ārzemēs saslimstu?",
            "answer": "Vispirms zvaniet uz polisē norādīto palīdzības numuru. Tur pateiks, uz kuru klīniku doties, un bieži norēķinās ar to tieši."
          },
          {
            "question": "Vai darba braucieni ir segti?",
            "answer": "Biroja tipa darbs parasti ir segts, bet fizisks darbs vai darbs ar iekārtām jānorāda atsevišķi."
          }
        ],
        "seo": {
          "title": "Ceļojumu apdrošināšana — cenas un segums ārzemēs | kreditiem.lv Apdrošināšana",
          "description": "Ceļojumu apdrošināšana ar medicīnisko segumu, bagāžas un ceļojuma atcelšanas aizsardzību. Vienreizēja vai gada polise — saņemiet piedāvājumu."
        },
        "related": [
          "veselibas-apdrosinasana",
          "nelaimes-gadijumu-apdrosinasana",
          "octa"
        ],
        "form_fields": [
          {
            "name": "destination",
            "label": "Galamērķis",
            "type": "text",
            "required": true,
            "placeholder": "Valsts vai reģions, piemēram, Itālija"
          },
          {
            "name": "travellers_count",
            "label": "Ceļotāju skaits",
            "type": "number",
            "required": true,
            "placeholder": 2
          },
          {
            "name": "start_date",
            "label": "Ceļojuma sākums",
            "type": "date",
            "required": true
          },
          {
            "name": "end_date",
            "label": "Ceļojuma beigas",
            "type": "date",
            "required": true
          },
          {
            "name": "policy_type",
            "label": "Polises veids",
            "type": "select",
            "required": false,
            "options": [
              "Vienreizējs brauciens",
              "Gada polise"
            ]
          },
          {
            "name": "purpose",
            "label": "Ceļojuma mērķis",
            "type": "select",
            "required": false,
            "options": [
              "Atpūta",
              "Darbs",
              "Mācības",
              "Sports"
            ]
          },
          {
            "name": "extras",
            "label": "Papildu segumi",
            "type": "multiselect",
            "required": false,
            "options": [
              "Ziemas sporta veidi",
              "Aktīvā atpūta un piedzīvojumu sports",
              "Ceļojuma atcelšana",
              "Bagāžas paaugstināts limits",
              "Auto noma un pašrisks"
            ]
          }
        ]
      },
      "civiltiesiska-atbildiba": {
        "name": "Civiltiesiskās atbildības apdrošināšana",
        "short_name": "Atbildība",
        "internal_name": "liability",
        "category": "liability",
        "audiences": [
          "private",
          "business"
        ],
        "icon": "scale",
        "position": 9,
        "tagline": "Sedz zaudējumus, ko nodarāt citiem",
        "summary": "Atlīdzina trešajām personām nodarītos mantiskos un personiskos zaudējumus, tostarp juridiskās izmaksas, ja pret jums izvirzīta prasība.",
        "hero": {
          "title": "Civiltiesiskā atbildība privātpersonām un uzņēmumiem",
          "subtitle": "Kļūdas gadās visiem — applūdināts kaimiņa dzīvoklis, klientam bojāta manta vai apmeklētāja trauma veikalā. Atbildības polise sedz šos zaudējumus un palīdz izvairīties no tiesāšanās par saviem līdzekļiem.",
          "highlights": [
            "Sedz mantiskos un personiskos zaudējumus",
            "Iekļauj juridiskās aizstāvības izmaksas",
            "Nepieciešama daudzās nozarēs un iepirkumos"
          ]
        },
        "benefits": [
          {
            "icon": "scale",
            "title": "Zaudējumi trešajām personām",
            "description": "Apdrošinātājs atlīdzina cietušajam mantas bojājumus, ārstēšanās izdevumus un citus pamatotus zaudējumus polises limita ietvaros."
          },
          {
            "icon": "gavel",
            "title": "Juridiskā aizstāvība",
            "description": "Sedz advokāta un ekspertīžu izmaksas, arī tad, ja prasība galu galā izrādās nepamatota."
          },
          {
            "icon": "briefcase",
            "title": "Profesionālā atbildība",
            "description": "Grāmatvežiem, projektētājiem, IT un citiem pakalpojumu sniedzējiem — sedz zaudējumus no profesionālas kļūdas."
          },
          {
            "icon": "store",
            "title": "Atbildība par telpām",
            "description": "Ja apmeklētājs paslīd veikalā vai no ēkas krīt sniegs uz automašīnu, zaudējumus sedz polise, nevis uzņēmums."
          }
        ],
        "covered": [
          "Trešajām personām nodarīti mantas bojājumi",
          "Personām nodarīts kaitējums veselībai",
          "Juridiskās izmaksas un ekspertīzes",
          "Zaudējumi, ko rada uzņēmuma darbinieki, veicot darba pienākumus",
          "Zaudējumi no pārdotas preces vai sniegta pakalpojuma trūkumiem, ja iekļauts"
        ],
        "not_covered": [
          "Zaudējumi, kas nodarīti apzināti vai rupjas neuzmanības dēļ",
          "Līgumsodi un soda naudas",
          "Paša īpašumam nodarītie bojājumi",
          "Zaudējumi, kas radušies pirms polises spēkā stāšanās",
          "Darbinieku traumas darbā, ko sedz nelaimes gadījumu polise"
        ],
        "pricing": {
          "intro": "Cena atkarīga no atbildības limita un darbības jomas. Privātpersonām atbildības segums bieži ir daļa no mājokļa polises un maksā dažus eiro mēnesī.",
          "examples": [
            {
              "label": "Privātpersonai, limits 10 000 €",
              "price": "15–40 € / gadā",
              "note": "Bieži iekļauts mājokļa polisē"
            },
            {
              "label": "Pakalpojumu uzņēmumam, limits 50 000 €",
              "price": "150–400 € / gadā",
              "note": "Atkarīgs no nozares"
            },
            {
              "label": "Profesionālā atbildība, limits 200 000 €",
              "price": "500–1 800 € / gadā",
              "note": "Projektēšana, grāmatvedība, konsultācijas"
            }
          ],
          "factors": [
            "Atbildības limits un pašrisks",
            "Nozare un darbības riska pakāpe",
            "Apgrozījums un darbinieku skaits",
            "Iepriekšējās prasības un to apmērs"
          ]
        },
        "faq": [
          {
            "question": "Kad atbildības apdrošināšana ir obligāta?",
            "answer": "Atsevišķām profesijām un darbības veidiem tā noteikta normatīvajos aktos, piemēram, būvniecībā un dažos regulētos pakalpojumos. Bieži to prasa arī publiskie iepirkumi un lielie klienti."
          },
          {
            "question": "Vai polise sedz manu paša mantu?",
            "answer": "Nē. Atbildības polise attiecas tikai uz citiem nodarītiem zaudējumiem. Savu īpašumu sedz īpašuma vai mājokļa apdrošināšana."
          },
          {
            "question": "Cik lielu limitu izvēlēties?",
            "answer": "Limitam jāatbilst iespējamā zaudējuma apmēram, nevis apgrozījumam. Uzņēmumiem, kas strādā ar dārgu klientu mantu, ieteicams sākt no 50 000 €."
          },
          {
            "question": "Vai sedz darbinieka pieļautu kļūdu?",
            "answer": "Jā, ja darbinieks rīkojies darba pienākumu ietvaros. Apzināta kaitēšana netiek segta."
          },
          {
            "question": "Vai polise darbojas ārpus Latvijas?",
            "answer": "Teritoriju norāda polisē. Uzņēmumiem, kas strādā ārzemēs, segumu var paplašināt uz Eiropas Savienību vai plašāk."
          }
        ],
        "seo": {
          "title": "Civiltiesiskās atbildības apdrošināšana | kreditiem.lv Apdrošināšana",
          "description": "Civiltiesiskās atbildības apdrošināšana sedz trešajām personām nodarītos zaudējumus un juridiskās izmaksas. Risinājumi privātpersonām un uzņēmumiem."
        },
        "related": [
          "uznemumu-apdrosinasana",
          "majokla-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "activity_type",
            "label": "Darbības veids",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, būvniecības pakalpojumi, kafejnīca, IT izstrāde"
          },
          {
            "name": "coverage_limit",
            "label": "Vēlamais atbildības limits",
            "type": "select",
            "required": false,
            "options": [
              "10 000 €",
              "25 000 €",
              "50 000 €",
              "100 000 €",
              "200 000 € vai vairāk",
              "Vēl nezinu"
            ]
          },
          {
            "name": "annual_turnover",
            "label": "Gada apgrozījums",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "employees",
            "label": "Darbinieku skaits",
            "type": "number",
            "required": false
          },
          {
            "name": "risk_description",
            "label": "Kādus riskus vēlaties nosegt?",
            "type": "textarea",
            "required": false,
            "placeholder": "Piemēram, klientu mantas bojājumi, apmeklētāju traumas telpās"
          }
        ]
      },
      "darbinieku-apdrosinasana": {
        "name": "Darbinieku apdrošināšana",
        "short_name": "Darbinieki",
        "internal_name": "employee",
        "category": "employee",
        "audiences": [
          "business"
        ],
        "icon": "users",
        "position": 10,
        "tagline": "Veselības un nelaimes gadījumu segums kolektīvam",
        "summary": "Darbinieku labumu pakete: veselības apdrošināšana, nelaimes gadījumi un dzīvības segums ar nodokļu atvieglojumiem likumā noteiktajā apmērā.",
        "hero": {
          "title": "Darbinieku apdrošināšana, kas palīdz noturēt komandu",
          "subtitle": "Veselības polise ir viens no biežāk pieprasītajiem labumiem darba tirgū. Palīdzam izveidot paketi, kas iekļaujas budžetā un ir saprotama darbiniekiem.",
          "highlights": [
            "Nodokļu atvieglojumi noteiktā apmērā gadā",
            "Vienota programma visam kolektīvam",
            "Iespēja pievienot ģimenes locekļus par darbinieka līdzekļiem"
          ]
        },
        "benefits": [
          {
            "icon": "heart-pulse",
            "title": "Veselības programma",
            "description": "Ārstu konsultācijas, izmeklējumi, zobārstniecība un fizikālā terapija atbilstoši izvēlētajiem limitiem."
          },
          {
            "icon": "bandage",
            "title": "Nelaimes gadījumi",
            "description": "Naudas izmaksa traumas vai darbnespējas gadījumā, arī ārpus darba laika, ja izvēlēts 24 stundu segums."
          },
          {
            "icon": "shield",
            "title": "Dzīvības apdrošināšana",
            "description": "Nodrošina darbinieka ģimeni smagākajos gadījumos un bieži tiek iekļauta vadošo darbinieku paketēs."
          },
          {
            "icon": "calculator",
            "title": "Nodokļu efektivitāte",
            "description": "Darba devēja iemaksas noteiktā apmērā gadā uz vienu darbinieku netiek apliktas ar algas nodokļiem, ja izpildīti likuma nosacījumi."
          }
        ],
        "covered": [
          "Ārstu konsultācijas un izmeklējumi programmas ietvaros",
          "Zobārstniecība un profilaktiskās apskates",
          "Traumas un darbnespēja",
          "Kritiskās slimības, ja iekļautas programmā",
          "Dzīvības risks, ja izvēlēts attiecīgais segums"
        ],
        "not_covered": [
          "Estētiskās procedūras un plastiskā ķirurģija",
          "Ārstēšanās ārzemēs bez ceļojumu polises",
          "Hronisku slimību ārstēšana, kas sākusies pirms polises",
          "Pakalpojumi ārpus apdrošinātāja sadarbības klīnikām, ja tā noteikts",
          "Darbinieki, kas nav iekļauti apdrošināto sarakstā"
        ],
        "pricing": {
          "intro": "Cena tiek rēķināta uz vienu darbinieku, un tā samazinās, pieaugot grupas lielumam. Bieži uzņēmumi sāk ar pamata programmu un vēlāk to paplašina.",
          "examples": [
            {
              "label": "10 darbinieki, pamata veselības programma",
              "price": "220–360 € / darbinieku gadā",
              "note": "Konsultācijas un izmeklējumi"
            },
            {
              "label": "25 darbinieki, programma ar zobārstniecību",
              "price": "300–520 € / darbinieku gadā",
              "note": "Ar gada limitiem"
            },
            {
              "label": "Nelaimes gadījumu polise 30 darbiniekiem",
              "price": "25–60 € / darbinieku gadā",
              "note": "24 stundu segums"
            }
          ],
          "factors": [
            "Darbinieku skaits un vecuma struktūra",
            "Programmas apjoms un gada limiti",
            "Nozare un darba riska pakāpe",
            "Vēsturiskā polises izmantošana"
          ]
        },
        "faq": [
          {
            "question": "Cik darbinieku nepieciešams grupas polisei?",
            "answer": "Vairums apdrošinātāju grupas nosacījumus piemēro no pieciem darbiniekiem, bet atsevišķi piedāvājumi ir pieejami arī mazākiem uzņēmumiem."
          },
          {
            "question": "Vai visiem darbiniekiem jābūt vienādai programmai?",
            "answer": "Programmas var atšķirties pa grupām, taču nodokļu atvieglojumu nosacījumi paredz vienlīdzīgu pieejamību, tāpēc dalījumam jābūt pamatotam."
          },
          {
            "question": "Vai darbinieks var pievienot ģimeni?",
            "answer": "Jā, parasti par savu līdzmaksājumu. Tas ir populārs risinājums, kas uzņēmumam neizmaksā papildus."
          },
          {
            "question": "Kas notiek, ja darbinieks aiziet no darba?",
            "answer": "Polisi attiecīgajai personai pārtrauc, un vietā var pievienot jaunu darbinieku. Neizmantoto prēmiju parasti pārrēķina."
          },
          {
            "question": "Vai polise sedz komandējumus ārzemēs?",
            "answer": "Veselības polise darbojas Latvijā. Komandējumiem nepieciešama ceļojumu apdrošināšana, ko var noformēt kā gada polisi uzņēmumam."
          }
        ],
        "seo": {
          "title": "Darbinieku apdrošināšana — veselība un nelaimes gadījumi | kreditiem.lv Apdrošināšana",
          "description": "Darbinieku apdrošināšana uzņēmumiem: veselības programmas, nelaimes gadījumi un dzīvības segums ar nodokļu atvieglojumiem. Saņemiet piedāvājumu."
        },
        "related": [
          "veselibas-apdrosinasana",
          "nelaimes-gadijumu-apdrosinasana",
          "uznemumu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "employees_covered",
            "label": "Apdrošināmo darbinieku skaits",
            "type": "number",
            "required": true,
            "placeholder": 10
          },
          {
            "name": "coverage_types",
            "label": "Kāds segums nepieciešams?",
            "type": "multiselect",
            "required": true,
            "options": [
              "Veselības apdrošināšana",
              "Nelaimes gadījumu apdrošināšana",
              "Dzīvības apdrošināšana",
              "Kritiskās slimības",
              "Ceļojumu apdrošināšana komandējumiem"
            ]
          },
          {
            "name": "budget_per_employee",
            "label": "Budžets uz vienu darbinieku gadā",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "current_insurer",
            "label": "Vai pašlaik ir spēkā esoša polise?",
            "type": "select",
            "required": false,
            "options": [
              "Nē, būs pirmā",
              "Jā, meklējam labāku piedāvājumu",
              "Jā, beidzas tuvākajā laikā"
            ]
          },
          {
            "name": "notes",
            "label": "Papildu vēlmes",
            "type": "textarea",
            "required": false,
            "placeholder": "Piemēram, svarīga zobārstniecība un sporta kompensācija"
          }
        ]
      },
      "kasko": {
        "name": "KASKO",
        "short_name": "KASKO",
        "internal_name": "kasko",
        "category": "auto",
        "audiences": [
          "private",
          "business"
        ],
        "icon": "car-shield",
        "position": 2,
        "tagline": "Brīvprātīgā transportlīdzekļa apdrošināšana",
        "summary": "Sedz jūsu paša automašīnas bojājumus — sadursmē, zādzībā, ugunsgrēkā vai dabas stihijā. Segumu un pašrisku izvēlaties jūs.",
        "hero": {
          "title": "KASKO, kas sedz jūsu automašīnu",
          "subtitle": "KASKO sedz jūsu automašīnas bojājumus — sadursmē, zādzībā vai dabas stihijā. Palīdzam izvēlēties segumu un sagatavot piedāvājumu.",
          "highlights": [
            "Sedz arī tad, ja negadījumā vainīgais esat jūs",
            "Pašrisku varat izvēlēties, lai samazinātu prēmiju",
            "Iespējami papildu segumi: stikli, riepas, aizvietojošais auto"
          ]
        },
        "benefits": [
          {
            "icon": "car-shield",
            "title": "Sadursmes un ceļa bojājumi",
            "description": "Remontu sedz neatkarīgi no vainas, tāpēc KASKO palīdz arī tad, ja pats esat izraisījis negadījumu vai iebraucis bedrē."
          },
          {
            "icon": "lock",
            "title": "Zādzība un vandālisms",
            "description": "Sedz automašīnas zādzību, kā arī apzinātus bojājumus, piemēram, saskrāpētas durvis stāvvietā."
          },
          {
            "icon": "cloud",
            "title": "Dabas stihijas un ugunsgrēks",
            "description": "Krusa, vētrā uzkritis koks, plūdi vai ugunsgrēks ir standarta riski lielākajā daļā KASKO polišu."
          },
          {
            "icon": "wrench",
            "title": "Papildu pakalpojumi",
            "description": "Pēc izvēles var pievienot auto evakuāciju, aizvietojošo automašīnu, stiklu apdrošināšanu bez pašriska vai palīdzību uz ceļa."
          }
        ],
        "covered": [
          "Sadursme ar citu transportlīdzekli, šķērsli vai dzīvnieku",
          "Automašīnas zādzība un tās daļu zādzība",
          "Ugunsgrēks, sprādziens un dabas stihiju radītie bojājumi",
          "Trešo personu prettiesiska rīcība, tostarp vandālisms",
          "Stiklu bojājumi un, atkarībā no polises, riepu bojājumi"
        ],
        "not_covered": [
          "Nolietojums, tehniskās kļūmes un remonts bez negadījuma",
          "Bojājumi, braucot alkohola vai narkotisko vielu ietekmē",
          "Braukšana bez atbilstošas kategorijas vadītāja apliecības",
          "Automašīnas izmantošana sacīkstēs vai ārpus ceļiem",
          "Manta salonā un bagāžā, ja nav atsevišķa seguma"
        ],
        "pricing": {
          "intro": "KASKO prēmija parasti ir 2–6 % no automašīnas vērtības gadā. Lielāks pašrisks samazina prēmiju, bet palielina jūsu maksājumu negadījumā.",
          "examples": [
            {
              "label": "Automašīna 8 000 € vērtībā",
              "price": "260–450 € / gadā",
              "note": "Pašrisks 150–300 €"
            },
            {
              "label": "Automašīna 20 000 € vērtībā",
              "price": "550–900 € / gadā",
              "note": "Pašrisks 200–400 €"
            },
            {
              "label": "Jauns auto līzingā 35 000 €",
              "price": "900–1 500 € / gadā",
              "note": "Līzinga devējs bieži nosaka minimālo segumu"
            }
          ],
          "factors": [
            "Automašīnas tirgus vērtība un modeļa remonta izmaksas",
            "Izvēlētais pašrisks un papildu segumi",
            "Vadītāja vecums, pieredze un negadījumu vēsture",
            "Glabāšanas vieta un pretaizdzīšanas aprīkojums"
          ]
        },
        "faq": [
          {
            "question": "Vai KASKO ir obligāta?",
            "answer": "Likums to neprasa. Tomēr līzinga vai kredīta gadījumā finansētājs gandrīz vienmēr pieprasa KASKO visu līguma laiku."
          },
          {
            "question": "Kas ir pašrisks?",
            "answer": "Tā ir summa, ko katrā gadījumā apmaksājat jūs. Piemēram, ar 200 € pašrisku un 1 200 € remontu apdrošinātājs atlīdzina 1 000 €."
          },
          {
            "question": "Vai KASKO sedz bedrē bojātu riteni?",
            "answer": "Riepu un diska bojājumi var būt iekļauti kā papildu segums. Pieteikumā norādiet, ja tas jums ir svarīgi — iekļausim piedāvājumā."
          },
          {
            "question": "Kas notiek, ja automašīna ir pilnībā bojāta?",
            "answer": "Ja remonts nav ekonomiski pamatots, apdrošinātājs izmaksā automašīnas tirgus vērtību pirms negadījuma, atskaitot pašrisku un atlikumu vērtību."
          },
          {
            "question": "Vai varu apvienot OCTA un KASKO?",
            "answer": "Jā, un tas parasti ir izdevīgāk. Vairums apdrošinātāju piedāvā atlaidi, ja abas polises noformējat kopā."
          }
        ],
        "seo": {
          "title": "KASKO apdrošināšana — segums, cenas un pieteikums | kreditiem.lv Apdrošināšana",
          "description": "KASKO sedz jūsu automašīnas bojājumus sadursmē, zādzībā un dabas stihijā. Aizpildiet pieteikumu un saņemiet piedāvājumu."
        },
        "related": [
          "octa",
          "majokla-apdrosinasana",
          "celojumu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "vehicle_make",
            "label": "Marka",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, Toyota"
          },
          {
            "name": "vehicle_model",
            "label": "Modelis",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, RAV4"
          },
          {
            "name": "vehicle_year",
            "label": "Izlaiduma gads",
            "type": "number",
            "required": true,
            "placeholder": 2019
          },
          {
            "name": "plate_number",
            "label": "Reģistrācijas numurs",
            "type": "text",
            "required": true,
            "placeholder": "AB-1234"
          },
          {
            "name": "vehicle_value",
            "label": "Aptuvenā tirgus vērtība",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "bonus_malus",
            "label": "Bonus-Malus klase",
            "type": "select",
            "required": false,
            "options": [
              "Nezinu",
              "1–3",
              "4–5",
              "6–7",
              "8–10"
            ]
          },
          {
            "name": "leasing",
            "label": "Vai automašīna ir līzingā?",
            "type": "select",
            "required": false,
            "options": [
              "Nē",
              "Jā"
            ]
          },
          {
            "name": "extras",
            "label": "Papildu segumi",
            "type": "multiselect",
            "required": false,
            "options": [
              "Stiklu apdrošināšana bez pašriska",
              "Aizvietojošā automašīna",
              "Auto evakuācija",
              "Riepu un disku segums",
              "Palīdzība uz ceļa ārzemēs"
            ]
          }
        ]
      },
      "komercipasuma-apdrosinasana": {
        "name": "Komercīpašuma apdrošināšana",
        "short_name": "Komercīpašums",
        "internal_name": "commercial_real_estate",
        "category": "business_property",
        "audiences": [
          "business"
        ],
        "icon": "building-2",
        "position": 11,
        "tagline": "Biroji, ražotnes, noliktavas un tirdzniecības telpas",
        "summary": "Sedz komercplatību ēkas, apdari, iekārtas un krājumus, kā arī peļņas zaudējumus, ja darbība uz laiku ir jāpārtrauc.",
        "hero": {
          "title": "Komercīpašuma apdrošināšana ar pārtraukuma segumu",
          "subtitle": "Ugunsgrēks noliktavā nozīmē ne tikai bojātas preces, bet arī apstājušos darbību. Tāpēc komercīpašuma polisē svarīgākais papildinājums ir peļņas pārtraukuma segums.",
          "highlights": [
            "Ēka, apdare, iekārtas un krājumi",
            "Peļņas zaudējumu segums darbības pārtraukumā",
            "Segums arī iznomātām telpām"
          ]
        },
        "benefits": [
          {
            "icon": "building-2",
            "title": "Ēkas un telpas",
            "description": "Biroja, ražošanas, noliktavas vai tirdzniecības telpas kopā ar iekšējo apdari un inženiersistēmām."
          },
          {
            "icon": "cpu",
            "title": "Iekārtas un tehnika",
            "description": "Ražošanas līnijas, datortehnika, aprīkojums un instrumenti, tostarp bojājumi elektrotehnisku iemeslu dēļ."
          },
          {
            "icon": "trending-down",
            "title": "Darbības pārtraukums",
            "description": "Atlīdzina negūto peļņu un pastāvīgās izmaksas, kamēr telpas tiek atjaunotas pēc apdrošināšanas gadījuma."
          },
          {
            "icon": "package",
            "title": "Preču krājumi",
            "description": "Noliktavā un tirdzniecības zālē esošās preces pēc vidējā vai maksimālā atlikuma principa."
          }
        ],
        "covered": [
          "Ugunsgrēks, sprādziens, dūmi un zibens",
          "Ūdens noplūde no inženiertīkliem un sprinkleru sistēmām",
          "Dabas stihijas — vētra, krusa, plūdi, sniega slodze",
          "Zādzība ar ielaušanos, laupīšana un vandālisms",
          "Darbības pārtraukums, ja iekļauts attiecīgais segums"
        ],
        "not_covered": [
          "Nolietojums, korozija un plānotā apkope",
          "Ražošanas defekti un preču kvalitātes problēmas",
          "Iekārtu kļūmes bez ārēja notikuma, ja nav mašīnu apdrošināšanas",
          "Zaudējumi kibernoziegumu dēļ bez atsevišķas kiberpolises",
          "Neapsargātas būvniecības objektu teritorijas bez vienošanās"
        ],
        "pricing": {
          "intro": "Prēmija atkarīga no darbības veida un ugunsdrošības risinājumiem. Ražošanā tā ir augstāka nekā birojos.",
          "examples": [
            {
              "label": "Birojs 300 m², apdare un tehnika",
              "price": "300–700 € / gadā",
              "note": "Apdrošinājuma summa līdz 200 000 €"
            },
            {
              "label": "Noliktava ar krājumiem 500 000 €",
              "price": "1 200–3 000 € / gadā",
              "note": "Atkarīgs no ugunsdrošības sistēmām"
            },
            {
              "label": "Ražotne ar iekārtām 1 milj. €",
              "price": "2 500–7 000 € / gadā",
              "note": "Ar darbības pārtraukuma segumu"
            }
          ],
          "factors": [
            "Darbības veids un uzglabājamo preču raksturs",
            "Ēkas konstrukcija un ugunsdrošības sistēmas",
            "Apsardze, videonovērošana un piekļuves kontrole",
            "Vēlamais darbības pārtraukuma periods"
          ]
        },
        "faq": [
          {
            "question": "Vai jāapdrošina telpas, ko nomājam?",
            "answer": "Ēkas konstrukcijas parasti apdrošina īpašnieks, bet nomnieks apdrošina savu apdari, iekārtas, krājumus un atbildību. To parasti nosaka nomas līgums."
          },
          {
            "question": "Kas ir darbības pārtraukuma apdrošināšana?",
            "answer": "Tā atlīdzina negūto peļņu un pastāvīgās izmaksas laikā, kamēr uzņēmums nevar strādāt pēc apdrošināšanas gadījuma. Periodu izvēlas no trim līdz divpadsmit mēnešiem."
          },
          {
            "question": "Kā tiek noteikta krājumu summa?",
            "answer": "Visbiežāk pēc vidējā atlikuma gada laikā. Sezonālā biznesā ieteicams norādīt maksimālo atlikumu, lai nerastos nepietiekama apdrošināšana."
          },
          {
            "question": "Vai polise sedz iekārtu remontu?",
            "answer": "Standarta polise sedz bojājumus no ārējiem notikumiem. Iekšējas kļūmes sedz atsevišķa mašīnu un iekārtu apdrošināšana."
          },
          {
            "question": "Vai nepieciešama ugunsdrošības sistēma?",
            "answer": "Ne vienmēr obligāti, bet automātiskā ugunsgrēka atklāšana un apsardze būtiski samazina prēmiju un dažkārt ir priekšnoteikums segumam."
          }
        ],
        "seo": {
          "title": "Komercīpašuma apdrošināšana — telpas, iekārtas, krājumi | kreditiem.lv Apdrošināšana",
          "description": "Komercīpašuma apdrošināšana biroju, ražošanas, noliktavas un tirdzniecības telpām, tostarp darbības pārtraukuma segums. Saņemiet piedāvājumu."
        },
        "related": [
          "uznemumu-apdrosinasana",
          "civiltiesiska-atbildiba",
          "kravu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "address",
            "label": "Objekta adrese",
            "type": "text",
            "required": true
          },
          {
            "name": "property_type",
            "label": "Telpu veids",
            "type": "select",
            "required": true,
            "options": [
              "Birojs",
              "Ražotne",
              "Noliktava",
              "Tirdzniecības telpas",
              "Servisa centrs",
              "Cits"
            ]
          },
          {
            "name": "area",
            "label": "Platība",
            "type": "number",
            "required": true,
            "unit": "m²"
          },
          {
            "name": "property_value",
            "label": "Apdrošināmā vērtība",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "ownership",
            "label": "Telpu statuss",
            "type": "select",
            "required": false,
            "options": [
              "Īpašums",
              "Noma",
              "Iznomājam citiem"
            ]
          },
          {
            "name": "additional_risks",
            "label": "Papildu riski",
            "type": "multiselect",
            "required": false,
            "options": [
              "Darbības pārtraukums",
              "Preču krājumi",
              "Iekārtu bojājumi un kļūmes",
              "Naudas apdrošināšana",
              "Stiklu apdrošināšana",
              "Civiltiesiskā atbildība"
            ]
          },
          {
            "name": "notes",
            "label": "Papildu informācija",
            "type": "textarea",
            "required": false,
            "placeholder": "Piemēram, ugunsdrošības sistēmas, apsardze, ēkas vecums"
          }
        ]
      },
      "kravu-apdrosinasana": {
        "name": "Kravu apdrošināšana",
        "short_name": "Kravas",
        "internal_name": "Freight",
        "category": "cargo",
        "audiences": [
          "business"
        ],
        "icon": "truck",
        "position": 12,
        "tagline": "Preču aizsardzība pārvadājuma laikā",
        "summary": "Sedz kravas bojājumus, zādzību un bojāeju pārvadājuma laikā pa autoceļiem, jūru, gaisu vai dzelzceļu — neatkarīgi no pārvadātāja atbildības limitiem.",
        "hero": {
          "title": "Kravu apdrošināšana ar reālu seguma summu",
          "subtitle": "Pārvadātāja atbildība ir ierobežota ar starptautiskām konvencijām un bieži nesedz kravas patieso vērtību. Kravu polise sedz preces vērtību pēc rēķina, nevis pēc kilogramiem.",
          "highlights": [
            "Segums pēc kravas rēķina vērtības",
            "Vienreizēji pārvadājumi vai gada polise",
            "Darbojas visos transporta veidos"
          ]
        },
        "benefits": [
          {
            "icon": "truck",
            "title": "Visi transporta veidi",
            "description": "Autopārvadājumi, jūras, gaisa un dzelzceļa transports, tostarp multimodālie maršruti ar pārkraušanu."
          },
          {
            "icon": "shield",
            "title": "Plašs risku segums",
            "description": "Sadursme, apgāšanās, zādzība, ūdens iekļūšana, kā arī kravas bojāeja dabas stihijas dēļ."
          },
          {
            "icon": "file-text",
            "title": "Segums pēc vērtības",
            "description": "Atlīdzību aprēķina no kravas rēķina summas, pievienojot transporta izmaksas un, ja nepieciešams, plānoto peļņu."
          },
          {
            "icon": "repeat",
            "title": "Gada polise regulāriem sūtījumiem",
            "description": "Ja pārvadājumi notiek regulāri, gada polise ar apgrozījuma deklarēšanu ir lētāka par atsevišķām polisēm."
          }
        ],
        "covered": [
          "Kravas bojājumi transportlīdzekļa negadījumā",
          "Zādzība un kravas zudums pārvadājuma laikā",
          "Bojājumi iekraušanas un izkraušanas laikā, ja iekļauts",
          "Dabas stihijas un ūdens iekļūšana konteinerā",
          "Kravas glābšanas un utilizācijas izmaksas"
        ],
        "not_covered": [
          "Nepietiekams vai nepiemērots iepakojums",
          "Preces dabiskā bojāšanās un svara zudums",
          "Temperatūras režīma pārkāpumi bez refrižeratora seguma",
          "Aizturēšana muitā un administratīvie sodi",
          "Kavēšanās radītie netiešie zaudējumi"
        ],
        "pricing": {
          "intro": "Prēmija parasti ir 0,05–0,5 % no kravas vērtības vienam pārvadājumam. Gada polisēm to aprēķina no gada apgrozījuma.",
          "examples": [
            {
              "label": "Viens pārvadājums 30 000 € vērtībā",
              "price": "40–120 €",
              "note": "Autopārvadājums Eiropas Savienībā"
            },
            {
              "label": "Gada polise, apgrozījums 1 milj. €",
              "price": "1 200–3 500 € / gadā",
              "note": "Regulāri pārvadājumi"
            },
            {
              "label": "Jūras pārvadājums no Āzijas",
              "price": "0,15–0,5 % no vērtības",
              "note": "Atkarīgs no kravas veida"
            }
          ],
          "factors": [
            "Kravas veids un tā jutīgums pret bojājumiem",
            "Maršruts un transporta veids",
            "Iepakojums un pārkraušanas reižu skaits",
            "Gada apgrozījums un zaudējumu vēsture"
          ]
        },
        "faq": [
          {
            "question": "Vai pietiek ar pārvadātāja atbildības apdrošināšanu?",
            "answer": "Bieži nepietiek. Autopārvadājumos atbildība ir ierobežota pēc kravas svara, tāpēc dārgai, bet vieglai kravai atlīdzība var būt vairākas reizes mazāka par tās vērtību."
          },
          {
            "question": "Kas ir atbildīgs par iepakojumu?",
            "answer": "Kravas nosūtītājs. Ja bojājums radies nepiemērota iepakojuma dēļ, apdrošinātājs atlīdzību var atteikt."
          },
          {
            "question": "Vai sedz temperatūras režīma pārkāpumu?",
            "answer": "Tikai ar atsevišķu refrižeratora kravu segumu, kas paredz temperatūras kontroles nosacījumus visā maršrutā."
          },
          {
            "question": "Kā pieteikt atlīdzību?",
            "answer": "Bojājumi jāfiksē pieņemšanas dokumentos uzreiz, jāsagatavo fotoattēli, rēķini un pārvadājuma dokumenti. Pēc tam iesniedz pieteikumu apdrošinātājam."
          },
          {
            "question": "Vai polise sedz kravu noliktavā?",
            "answer": "Īslaicīga uzglabāšana maršruta laikā parasti ir segta. Ilgstoša uzglabāšana jāapdrošina ar īpašuma vai krājumu polisi."
          }
        ],
        "seo": {
          "title": "Kravu apdrošināšana — pārvadājumu segums | kreditiem.lv Apdrošināšana",
          "description": "Kravu apdrošināšana auto, jūras, gaisa un dzelzceļa pārvadājumiem. Segums pēc kravas vērtības, vienreizēji sūtījumi vai gada polise."
        },
        "related": [
          "uznemumu-apdrosinasana",
          "civiltiesiska-atbildiba",
          "komercipasuma-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "cargo_type",
            "label": "Kravas veids",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, elektronika, būvmateriāli, pārtika"
          },
          {
            "name": "transport_mode",
            "label": "Transporta veids",
            "type": "select",
            "required": true,
            "options": [
              "Autotransports",
              "Jūras transports",
              "Gaisa transports",
              "Dzelzceļš",
              "Multimodāls"
            ]
          },
          {
            "name": "routes",
            "label": "Galvenie maršruti",
            "type": "text",
            "required": false,
            "placeholder": "Piemēram, Latvija–Vācija, Ķīna–Rīga"
          },
          {
            "name": "policy_type",
            "label": "Polises veids",
            "type": "select",
            "required": false,
            "options": [
              "Viens pārvadājums",
              "Gada polise"
            ]
          },
          {
            "name": "single_shipment_value",
            "label": "Viena sūtījuma vērtība",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "annual_turnover",
            "label": "Gada pārvadājumu apgrozījums",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "special_conditions",
            "label": "Īpašie nosacījumi",
            "type": "multiselect",
            "required": false,
            "options": [
              "Temperatūras režīms",
              "Bīstamās kravas (ADR)",
              "Negabarīta krava",
              "Vairākas pārkraušanas",
              "Uzglabāšana maršruta laikā"
            ]
          }
        ]
      },
      "majokla-apdrosinasana": {
        "name": "Mājokļa apdrošināšana",
        "short_name": "Mājoklis",
        "internal_name": "home",
        "category": "property",
        "audiences": [
          "private"
        ],
        "icon": "home",
        "position": 3,
        "tagline": "Dzīvokļa un privātmājas aizsardzība",
        "summary": "Sedz dzīvokļa vai privātmājas konstrukcijas, iekšējo apdari un mājsaimniecības mantu — no ūdens noplūdes līdz vētrai un ugunsgrēkam.",
        "hero": {
          "title": "Mājokļa apdrošināšana bez pārmaksas",
          "subtitle": "Mājoklis ir dzīvošanai piemērots cilvēku miteklis — gan dzīvoklis, gan privātmāja. Palīdzam izvēlēties segumu pēc jūsu situācijas un aprēķināt reālu apdrošinājuma summu.",
          "highlights": [
            "Dzīvoklis vai privātmāja — viens pieteikums",
            "Ēka, apdare un manta vienā polisē",
            "Sedz arī kaimiņiem nodarītos zaudējumus"
          ]
        },
        "benefits": [
          {
            "icon": "home",
            "title": "Dzīvoklis un privātmāja",
            "description": "Segums gan daudzdzīvokļu mājas dzīvoklim, gan atsevišķai privātmājai — ar atbilstošiem papildu objektiem."
          },
          {
            "icon": "droplet",
            "title": "Ūdens noplūdes",
            "description": "Pārplīsusi caurule, bojāts boilers vai applūdusi grīda ir viens no biežākajiem apdrošināšanas gadījumiem mājokļos."
          },
          {
            "icon": "sofa",
            "title": "Mājsaimniecības manta",
            "description": "Mēbeles, sadzīves tehnika, apģērbs un elektronika. Vērtīgākas lietas, piemēram, rotaslietas, parasti norāda atsevišķi."
          },
          {
            "icon": "scale",
            "title": "Atbildība pret kaimiņiem",
            "description": "Ja no jūsu mājokļa noplūdis ūdens un bojāts kaimiņa īpašums, atbildības segums atlīdzina viņa zaudējumus."
          }
        ],
        "covered": [
          "Ugunsgrēks, dūmi, sprādziens un zibens spēriens",
          "Ūdens noplūde no iekšējiem inženiertīkliem un applūšana",
          "Vētra, krusa, plūdi un sniega slodze uz jumta",
          "Zādzība ar ielaušanos, laupīšana un vandālisms",
          "Trešajām personām nodarītie zaudējumi jūsu mājokļa dēļ"
        ],
        "not_covered": [
          "Pakāpeniska nolietošanās, pelējums un mitruma uzkrāšanās gadu gaitā",
          "Būvniecības un projektēšanas kļūdas",
          "Bojājumi neapdzīvotā mājoklī, kas ilgstoši nav apkurināts",
          "Remonta laikā radušies bojājumi bez atsevišķas vienošanās",
          "Nauda, vērtspapīri un kolekcijas, ja tie nav atsevišķi apdrošināti"
        ],
        "pricing": {
          "intro": "Prēmija ir atkarīga no mājokļa veida, platības, materiāla un apdrošinājuma summas. Dzīvokļa polise parasti ir lētāka, privātmājai — 0,1–0,3 % no atjaunošanas vērtības gadā.",
          "examples": [
            {
              "label": "Dzīvoklis 65 m² ar mantu",
              "price": "70–130 € / gadā",
              "note": "Apdare un manta"
            },
            {
              "label": "Privātmāja 120 m², mūra",
              "price": "180–320 € / gadā",
              "note": "Ēka, apdare un manta"
            },
            {
              "label": "Privātmāja 200 m² ar palīgceltnēm",
              "price": "320–550 € / gadā",
              "note": "Iekļauta garāža un pirts"
            }
          ],
          "factors": [
            "Mājokļa veids, platība, vecums un konstrukcijas materiāls",
            "Apdrošinājuma summa un izvēlētais pašrisks",
            "Atrašanās vieta un plūdu risks",
            "Signalizācija, apsardze un ūdens noplūdes sensori"
          ]
        },
        "faq": [
          {
            "question": "Kāda ir atšķirība starp dzīvokli un privātmāju polisē?",
            "answer": "Dzīvokļa polisē parasti sedz iekšējo apdari, mantu un atbildību pret kaimiņiem. Privātmājai var iekļaut arī ēkas konstrukcijas un papildu objektus — garāžu, pirti vai teritorijas labiekārtojumu."
          },
          {
            "question": "Kā aprēķināt apdrošinājuma summu?",
            "answer": "Par pamatu ņem atjaunošanas vērtību — cik izmaksātu atjaunot mājokli šodien. Tirgus cena var atšķirties no šīs summas."
          },
          {
            "question": "Vai man vajag polisi, ja māju apdrošina apsaimniekotājs?",
            "answer": "Jā. Apsaimniekotājs apdrošina kopīpašumu — kāpņu telpu, jumtu, koplietošanas tīklus. Jūsu dzīvokļa apdare un manta tajā nav iekļauta."
          },
          {
            "question": "Vai polise ir obligāta, ja māja ir hipotēkā?",
            "answer": "Banka gandrīz vienmēr pieprasa apdrošināt ēku par kredīta atlikumu vai atjaunošanas vērtību un norāda sevi par labuma guvēju."
          },
          {
            "question": "Kas jādara, ja noticis apdrošināšanas gadījums?",
            "answer": "Ierobežojiet bojājumus, nofotografējiet situāciju, ziņojiet apdrošinātājam un neveiciet remontu, pirms bojājumi ir fiksēti."
          }
        ],
        "seo": {
          "title": "Mājokļa apdrošināšana — dzīvoklis, privātmāja un cenas | kreditiem.lv Apdrošināšana",
          "description": "Mājokļa apdrošināšana sedz dzīvokli vai privātmāju — ēku, apdari un mantu. Ugunsgrēks, ūdens noplūde, vētra un zādzība. Saņemiet piedāvājumu."
        },
        "related": [
          "civiltiesiska-atbildiba",
          "celojumu-apdrosinasana",
          "nelaimes-gadijumu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "dwelling_type",
            "label": "Mājokļa veids",
            "type": "select",
            "required": true,
            "options": [
              "Dzīvoklis",
              "Privātmāja"
            ]
          },
          {
            "name": "address",
            "label": "Adrese",
            "type": "text",
            "required": true,
            "placeholder": "Iela, mājas un dzīvokļa numurs, pilsēta vai novads"
          },
          {
            "name": "construction_material",
            "label": "Konstrukcijas materiāls",
            "type": "select",
            "required": true,
            "options": [
              "Mūra",
              "Koka",
              "Jauktā konstrukcija"
            ]
          },
          {
            "name": "area",
            "label": "Platība",
            "type": "number",
            "required": true,
            "unit": "m²"
          },
          {
            "name": "security",
            "label": "Aizsardzības sistēmas",
            "type": "multiselect",
            "required": false,
            "options": [
              "Signalizācija",
              "Apsardze",
              "Ūdens noplūdes sensori",
              "Videonovērošana"
            ]
          },
          {
            "name": "ownership",
            "label": "Jūsu statuss",
            "type": "select",
            "required": true,
            "show_when": {
              "field": "dwelling_type",
              "values": [
                "Dzīvoklis"
              ]
            },
            "options": [
              "Īpašnieks, dzīvoju pats",
              "Īpašnieks, izīrēju",
              "Īrnieks"
            ]
          },
          {
            "name": "estimated_value",
            "label": "Aptuvenā atjaunošanas vērtība",
            "type": "number",
            "required": false,
            "unit": "€",
            "hint": "Ja nezināt, palīdzēsim aprēķināt."
          },
          {
            "name": "contents_value",
            "label": "Mantas apdrošinājuma summa",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "liability_limit",
            "label": "Atbildības limits pret kaimiņiem",
            "type": "select",
            "required": false,
            "show_when": {
              "field": "dwelling_type",
              "values": [
                "Dzīvoklis"
              ]
            },
            "options": [
              "3 000 €",
              "5 000 €",
              "10 000 €",
              "20 000 €"
            ]
          },
          {
            "name": "build_year",
            "label": "Būvniecības gads",
            "type": "number",
            "required": false
          },
          {
            "name": "additional_objects_house",
            "label": "Papildus apdrošināmi objekti",
            "type": "multiselect",
            "required": false,
            "show_when": {
              "field": "dwelling_type",
              "values": [
                "Privātmāja"
              ]
            },
            "options": [
              "Garāža",
              "Pirts",
              "Teritorijas labiekārtojums (žogs, barjeras, sienas, nojume, karoga masts u.c.)"
            ]
          },
          {
            "name": "additional_objects_apartment",
            "label": "Papildus apdrošināmi objekti",
            "type": "multiselect",
            "required": false,
            "show_when": {
              "field": "dwelling_type",
              "values": [
                "Dzīvoklis"
              ]
            },
            "options": [
              "Garāža"
            ]
          }
        ]
      },
      "nelaimes-gadijumu-apdrosinasana": {
        "name": "Nelaimes gadījumu apdrošināšana",
        "short_name": "Nelaimes gadījumi",
        "internal_name": "accident",
        "category": "accident",
        "audiences": [
          "private",
          "business"
        ],
        "icon": "bandage",
        "position": 7,
        "tagline": "Naudas atlīdzība traumas vai darbnespējas gadījumā",
        "summary": "Izmaksā fiksētu summu, ja notikusi trauma, iestājusies darbnespēja vai invaliditāte. Darbojas 24 stundas diennaktī, arī brīvajā laikā un sportā.",
        "hero": {
          "title": "Nelaimes gadījumu apdrošināšana visai diennaktij",
          "subtitle": "Atšķirībā no veselības polises šeit apdrošinātājs neapmaksā ārstu rēķinus, bet izmaksā naudu, ko varat izlietot pēc saviem ieskatiem — arī, lai kompensētu neizpelnīto algu.",
          "highlights": [
            "Izmaksa neatkarīgi no ārstēšanās izmaksām",
            "Segums 24/7, arī sportojot un ceļojot",
            "Populārs risinājums uzņēmumu darbiniekiem"
          ]
        },
        "benefits": [
          {
            "icon": "bandage",
            "title": "Traumas",
            "description": "Lūzumi, sasitumi, apdegumi un citas traumas tiek atlīdzinātas pēc polisē noteiktās tabulas procentu apmērā no apdrošinājuma summas."
          },
          {
            "icon": "calendar",
            "title": "Darbnespēja",
            "description": "Dienas nauda par slimības lapas laiku palīdz nosegt ienākumu kritumu, ja alga darbnespējā samazinās."
          },
          {
            "icon": "wheelchair",
            "title": "Invaliditāte",
            "description": "Ja trauma rada paliekošas sekas, izmaksā daļu vai visu apdrošinājuma summu atbilstoši noteiktajai pakāpei."
          },
          {
            "icon": "users",
            "title": "Ģimenei un darbiniekiem",
            "description": "Polisi var noformēt vienam cilvēkam, ģimenei vai visam uzņēmuma kolektīvam ar vienotu apdrošinājuma summu."
          }
        ],
        "covered": [
          "Traumas mājās, darbā, ceļā un atpūtā",
          "Kaulu lūzumi, izmežģījumi un apdegumi",
          "Pārejoša darbnespēja ar dienas naudu",
          "Paliekoša invaliditāte",
          "Nelaimes gadījuma izraisīta nāve"
        ],
        "not_covered": [
          "Slimības, kas nav saistītas ar nelaimes gadījumu",
          "Traumas alkohola vai narkotisko vielu ietekmē",
          "Apzināta pašsavainošanās",
          "Profesionālais sports, ja tas nav norādīts polisē",
          "Traumas, kas gūtas, izdarot noziedzīgu nodarījumu"
        ],
        "pricing": {
          "intro": "Cena ir viena no zemākajām apdrošināšanas tirgū un galvenokārt atkarīga no apdrošinājuma summas un nodarbošanās riska.",
          "examples": [
            {
              "label": "Biroja darbinieks, summa 10 000 €",
              "price": "20–45 € / gadā",
              "note": "Traumas un invaliditāte"
            },
            {
              "label": "Fizisks darbs, summa 15 000 €",
              "price": "60–120 € / gadā",
              "note": "Paaugstināts riska koeficients"
            },
            {
              "label": "Uzņēmumam, 20 darbinieki",
              "price": "25–60 € / darbinieku gadā",
              "note": "Grupas polise ar vienotiem nosacījumiem"
            }
          ],
          "factors": [
            "Apdrošinājuma summa",
            "Nodarbošanās un darba riska pakāpe",
            "Sporta veidi un vaļasprieki",
            "Iekļautie riski: dienas nauda, ārstēšanās izdevumi"
          ]
        },
        "faq": [
          {
            "question": "Ar ko tā atšķiras no veselības apdrošināšanas?",
            "answer": "Veselības polise apmaksā ārstu un izmeklējumus, bet nelaimes gadījumu polise izmaksā naudu par traumas sekām. Tās labi papildina viena otru."
          },
          {
            "question": "Vai segums darbojas ārpus darba laika?",
            "answer": "Standarta polise darbojas 24 stundas diennaktī. Uzņēmumi dažreiz izvēlas lētāku variantu, kas sedz tikai darba laiku."
          },
          {
            "question": "Kā tiek noteikta izmaksa?",
            "answer": "Katram traumas veidam polisē atbilst procents no apdrošinājuma summas. Piemēram, par konkrētu lūzumu var izmaksāt 5 % no summas."
          },
          {
            "question": "Vai sedz sporta traumas?",
            "answer": "Amatieru sportu parasti sedz. Cīņas sportu, motosportu un profesionālu sportu nepieciešams norādīt atsevišķi."
          },
          {
            "question": "Vai bērnus var apdrošināt?",
            "answer": "Jā, un bērnu polises ir īpaši populāras, jo sedz traumas skolā, treniņos un nometnēs."
          }
        ],
        "seo": {
          "title": "Nelaimes gadījumu apdrošināšana — segums un cenas | kreditiem.lv Apdrošināšana",
          "description": "Nelaimes gadījumu apdrošināšana izmaksā naudu traumas, darbnespējas vai invaliditātes gadījumā. Segums 24/7 privātpersonām un darbiniekiem."
        },
        "related": [
          "veselibas-apdrosinasana",
          "darbinieku-apdrosinasana",
          "celojumu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "insured_count",
            "label": "Apdrošināmo personu skaits",
            "type": "number",
            "required": true,
            "placeholder": 1
          },
          {
            "name": "coverage_amount",
            "label": "Vēlamā apdrošinājuma summa",
            "type": "number",
            "required": false,
            "unit": "€",
            "hint": "Bieži izvēlas 10 000–20 000 €."
          },
          {
            "name": "activity",
            "label": "Nodarbošanās raksturs",
            "type": "select",
            "required": true,
            "options": [
              "Biroja darbs",
              "Fizisks darbs",
              "Darbs ar iekārtām vai augstumā",
              "Skolēns vai students",
              "Cits"
            ]
          },
          {
            "name": "sports",
            "label": "Sporta veidi, ko regulāri praktizējat",
            "type": "text",
            "required": false,
            "placeholder": "Piemēram, futbols, slēpošana"
          },
          {
            "name": "extras",
            "label": "Papildu segumi",
            "type": "multiselect",
            "required": false,
            "options": [
              "Dienas nauda darbnespējā",
              "Ārstēšanās izdevumi",
              "Kritiskās slimības",
              "Segums bērniem"
            ]
          }
        ]
      },
      "octa": {
        "name": "OCTA",
        "short_name": "OCTA",
        "internal_name": "octa",
        "category": "auto",
        "audiences": [
          "private",
          "business"
        ],
        "icon": "car",
        "position": 1,
        "tagline": "Obligātā civiltiesiskā atbildības apdrošināšana",
        "summary": "Likumā noteiktā polise, kas sedz zaudējumus, ko ar transportlīdzekli nodarāt citiem. Bez tās braukt ar auto Latvijā nav atļauts.",
        "hero": {
          "title": "OCTA polise",
          "subtitle": "OCTA segumu nosaka likums. Aizpildiet pieteikumu, un sagatavosim piedāvājumu jūsu transportlīdzeklim.",
          "highlights": [
            "Likumā noteikts segums",
            "Polise e-pastā tajā pašā dienā",
            "Derīga visā Eiropas Ekonomikas zonā"
          ]
        },
        "benefits": [
          {
            "icon": "shield",
            "title": "Sedz citiem nodarītos zaudējumus",
            "description": "Ja esat vainīgais negadījumā, apdrošinātājs atlīdzina otras puses auto remontu, mantas bojājumus un veselībai nodarīto kaitējumu."
          },
          {
            "icon": "euro",
            "title": "Likumā noteikts segums",
            "description": "OCTA nosacījumus nosaka likums. Aizpildiet pieteikumu, un sagatavosim piedāvājumu jūsu transportlīdzeklim."
          },
          {
            "icon": "globe",
            "title": "Darbojas arī ārpus Latvijas",
            "description": "Latvijā izsniegta OCTA ir spēkā visās Eiropas Ekonomikas zonas valstīs un Šveicē, tāpēc atsevišķa Zaļā karte parasti nav vajadzīga."
          },
          {
            "icon": "clock",
            "title": "Termiņš pēc jūsu izvēles",
            "description": "Polisi var noformēt uz vienu mēnesi, trim, sešiem mēnešiem vai gadu. Gada polise gandrīz vienmēr ir izdevīgākā."
          }
        ],
        "covered": [
          "Otras puses transportlīdzekļa remonts vai atlikusī vērtība",
          "Ceļu satiksmes negadījumā bojāta manta un infrastruktūra",
          "Personu ārstēšanās, rehabilitācija un darbnespēja",
          "Apgādnieka zaudējums un ar to saistītie izdevumi",
          "Zaudējumi, kas nodarīti citās Eiropas Ekonomikas zonas valstīs"
        ],
        "not_covered": [
          "Jūsu paša automašīnas bojājumi — tos sedz KASKO",
          "Zaudējumi, kas nodarīti apzināti vai braucot bez tiesībām",
          "Negadījumi alkohola vai narkotisko vielu ietekmē",
          "Nolietojums, tehniskas kļūmes un ekspluatācijas izdevumi",
          "Manta, kas atradās jūsu paša automašīnā"
        ],
        "pricing": {
          "intro": "OCTA cenu aprēķina, ņemot vērā transportlīdzekli, tā lietošanas vietu un vadītāja apdrošināšanas vēsturi. Zemāk redzamie apmēri ir orientējoši.",
          "examples": [
            {
              "label": "Vieglā automašīna, Rīga, laba vēsture",
              "price": "no 65 € / gadā",
              "note": "Bonus-Malus klase 6 un augstāka"
            },
            {
              "label": "Vieglā automašīna, reģions",
              "price": "no 45 € / gadā",
              "note": "Ārpus Rīgas cena parasti ir zemāka"
            },
            {
              "label": "Pēc negadījuma, zema Bonus-Malus klase",
              "price": "150–400 € / gadā",
              "note": "Klase atjaunojas pakāpeniski"
            }
          ],
          "factors": [
            "Transportlīdzekļa veids, vecums un jauda",
            "Reģistrācijas vieta — Rīgā riski ir augstāki",
            "Bonus-Malus klase, kas atspoguļo iepriekšējos negadījumus",
            "Polises termiņš — īsāki termiņi ir dārgāki proporcionāli"
          ]
        },
        "faq": [
          {
            "question": "Kas notiek, ja braucu bez OCTA?",
            "answer": "Par braukšanu bez derīgas OCTA piemēro naudas sodu, un negadījuma gadījumā zaudējumus otrai pusei sākotnēji atlīdzina Transportlīdzekļu apdrošinātāju birojs, bet pēc tam tos piedzen no jums."
          },
          {
            "question": "Vai OCTA sedz manu automašīnu?",
            "answer": "Nē. OCTA sedz tikai zaudējumus, ko nodarāt citiem. Savas automašīnas bojājumus sedz KASKO, un tā ir brīvprātīga."
          },
          {
            "question": "Kas ir Bonus-Malus klase?",
            "answer": "Tā ir vienota vadītāja vēstures skala. Braucot bez negadījumiem, klase aug un cena samazinās; pēc negadījuma, kurā bijāt vainīgais, klase krīt."
          },
          {
            "question": "Vai OCTA pāriet uz jauno īpašnieku?",
            "answer": "Polise ir piesaistīta transportlīdzeklim, tāpēc pēc pārdošanas tā paliek spēkā, taču pārdevējs var lūgt pārtraukt polisi un atgriezt daļu prēmijas."
          },
          {
            "question": "Vai vajag Zaļo karti, braucot uz ārzemēm?",
            "answer": "Eiropas Ekonomikas zonā un Šveicē pietiek ar Latvijas OCTA. Zaļā karte nepieciešama, braucot uz valstīm ārpus šīs zonas, piemēram, uz Turciju."
          }
        ],
        "seo": {
          "title": "OCTA apdrošināšana — pieteikieties un saņemiet piedāvājumu | kreditiem.lv Apdrošināšana",
          "description": "OCTA polise jūsu transportlīdzeklim. Aizpildiet pieteikumu un saņemiet apdrošināšanas piedāvājumu."
        },
        "related": [
          "kasko",
          "celojumu-apdrosinasana",
          "nelaimes-gadijumu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "vehicle_make",
            "label": "Marka",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, Volkswagen"
          },
          {
            "name": "vehicle_model",
            "label": "Modelis",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, Passat"
          },
          {
            "name": "vehicle_year",
            "label": "Izlaiduma gads",
            "type": "number",
            "required": true,
            "placeholder": 2016
          },
          {
            "name": "plate_number",
            "label": "Reģistrācijas numurs",
            "type": "text",
            "required": true,
            "placeholder": "AB-1234"
          },
          {
            "name": "bonus_malus",
            "label": "Bonus-Malus klase",
            "type": "select",
            "required": false,
            "options": [
              "Nezinu",
              "1–3",
              "4–5",
              "6–7",
              "8–10"
            ],
            "hint": "Ja nezināt, atstājiet neaizpildītu — pārbaudīsim reģistrā."
          },
          {
            "name": "policy_term",
            "label": "Vēlamais polises termiņš",
            "type": "select",
            "required": false,
            "options": [
              "12 mēneši",
              "6 mēneši",
              "3 mēneši",
              "1 mēnesis"
            ]
          }
        ]
      },
      "uznemumu-apdrosinasana": {
        "name": "Uzņēmumu apdrošināšana",
        "short_name": "Uzņēmumiem",
        "internal_name": "company",
        "category": "business",
        "audiences": [
          "business"
        ],
        "icon": "briefcase",
        "position": 13,
        "tagline": "Kopējs risinājums uzņēmuma riskiem",
        "summary": "Viens līgums, kas apvieno īpašumu, atbildību, darbiniekus un darbības pārtraukumu. Piemērots maziem un vidējiem uzņēmumiem, kas nevēlas vairākas atsevišķas polises.",
        "hero": {
          "title": "Uzņēmuma apdrošināšana vienā līgumā",
          "subtitle": "Vairums mazo un vidējo uzņēmumu riskus sedz ar trim līdz četrām polisēm. Apvienojot tās vienā līgumā, samazinās gan administrēšana, gan cena, un nepaliek nesegtu vietu starp polisēm.",
          "highlights": [
            "Īpašums, atbildība un darbinieki kopā",
            "Viens atjaunošanas datums un viens rēķins",
            "Segums pielāgots nozares riskiem"
          ]
        },
        "benefits": [
          {
            "icon": "briefcase",
            "title": "Pielāgots nozarei",
            "description": "Kafejnīcai, būvniekiem, IT uzņēmumam un vairumtirgotājam riski atšķiras, tāpēc segumu veidojam no jūsu darbības, nevis no gatava saraksta."
          },
          {
            "icon": "building-2",
            "title": "Īpašums un iekārtas",
            "description": "Telpas, apdare, tehnika un krājumi, kā arī peļņas zaudējumi, ja darbība uz laiku apstājas."
          },
          {
            "icon": "scale",
            "title": "Atbildība pret klientiem",
            "description": "Vispārējā un profesionālā civiltiesiskā atbildība, tostarp juridiskās izmaksas."
          },
          {
            "icon": "users",
            "title": "Darbinieku segums",
            "description": "Veselības un nelaimes gadījumu apdrošināšana, ko var pievienot tam pašam līgumam."
          }
        ],
        "covered": [
          "Uzņēmuma īpašums: telpas, apdare, iekārtas, krājumi",
          "Darbības pārtraukums pēc apdrošināšanas gadījuma",
          "Vispārējā un profesionālā civiltiesiskā atbildība",
          "Darbinieku nelaimes gadījumi un veselības programma",
          "Naudas, stiklu un elektronikas riski, ja iekļauti"
        ],
        "not_covered": [
          "Uzņēmuma parādi, līgumsodi un naudas sodi",
          "Zaudējumi no tirgus apstākļu maiņas vai nepārdotām precēm",
          "Kiberuzbrukumi bez atsevišķas kiberapdrošināšanas",
          "Zināmi defekti un problēmas, kas pastāvēja pirms polises",
          "Darbības, kas nav norādītas apdrošināšanas līgumā"
        ],
        "pricing": {
          "intro": "Cenu veido no izvēlētajiem segumiem. Mazam pakalpojumu uzņēmumam bāzes pakete bieži sākas ap 400–600 € gadā.",
          "examples": [
            {
              "label": "Pakalpojumu uzņēmums, 5 darbinieki",
              "price": "400–800 € / gadā",
              "note": "Īpašums un atbildība"
            },
            {
              "label": "Tirdzniecības uzņēmums ar noliktavu",
              "price": "1 000–2 500 € / gadā",
              "note": "Krājumi un darbības pārtraukums"
            },
            {
              "label": "Ražošanas uzņēmums, 30 darbinieki",
              "price": "3 000–8 000 € / gadā",
              "note": "Iekārtas, atbildība, darbinieki"
            }
          ],
          "factors": [
            "Nozare un darbības veids",
            "Apgrozījums un darbinieku skaits",
            "Apdrošināmā īpašuma vērtība",
            "Iepriekšējo atlīdzību vēsture"
          ]
        },
        "faq": [
          {
            "question": "Kāpēc apvienot polises vienā līgumā?",
            "answer": "Tā ir vienkāršāka administrēšana un mazāks risks, ka kāds notikums nav segts nevienā no polisēm. Apdrošinātāji par kompleksu segumu bieži piedāvā atlaidi."
          },
          {
            "question": "No kāda apgrozījuma tas ir izdevīgi?",
            "answer": "Kompleksie risinājumi darbojas jau maziem uzņēmumiem. Tomēr, ja ir tikai viens risks, piemēram, biroja tehnika, atsevišķa polise var būt lētāka."
          },
          {
            "question": "Vai varam mainīt segumu gada laikā?",
            "answer": "Jā. Iegādājoties jaunas iekārtas vai pieņemot darbiniekus, polisi papildina ar pielikumu un pārrēķina prēmiju."
          },
          {
            "question": "Kādi dokumenti nepieciešami piedāvājumam?",
            "answer": "Pamatā pietiek ar darbības aprakstu, apgrozījumu, darbinieku skaitu un apdrošināmā īpašuma sarakstu ar vērtībām."
          },
          {
            "question": "Vai iepirkumos prasītie apliecinājumi tiek sagatavoti?",
            "answer": "Jā. Ja iepirkumā prasīts konkrēts atbildības limits, sagatavojam polisi ar attiecīgu limitu un apdrošinātāja izziņu."
          }
        ],
        "seo": {
          "title": "Uzņēmumu apdrošināšana — komplekss risinājums | kreditiem.lv Apdrošināšana",
          "description": "Uzņēmumu apdrošināšana: īpašums, civiltiesiskā atbildība, darbinieki un darbības pārtraukums vienā līgumā. Bezmaksas konsultācija."
        },
        "related": [
          "komercipasuma-apdrosinasana",
          "civiltiesiska-atbildiba",
          "darbinieku-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "business_activity",
            "label": "Darbības veids",
            "type": "text",
            "required": true,
            "placeholder": "Piemēram, kafejnīca, būvniecība, vairumtirdzniecība"
          },
          {
            "name": "annual_turnover",
            "label": "Gada apgrozījums",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "property_value",
            "label": "Īpašuma un iekārtu vērtība",
            "type": "number",
            "required": false,
            "unit": "€"
          },
          {
            "name": "employees",
            "label": "Darbinieku skaits",
            "type": "number",
            "required": false
          },
          {
            "name": "additional_risks",
            "label": "Papildu riski",
            "type": "multiselect",
            "required": false,
            "options": [
              "Civiltiesiskā atbildība",
              "Profesionālā atbildība",
              "Darbības pārtraukums",
              "Kravu pārvadājumi",
              "Darbinieku veselība",
              "Transportlīdzekļu parks",
              "Kiberriski"
            ]
          },
          {
            "name": "notes",
            "label": "Ko vēlaties pasargāt vispirms?",
            "type": "textarea",
            "required": false,
            "placeholder": "Piemēram, iekārtas ražotnē un atbildība pret klientiem"
          }
        ]
      },
      "veselibas-apdrosinasana": {
        "name": "Veselības apdrošināšana",
        "short_name": "Veselība",
        "internal_name": "health",
        "category": "health",
        "audiences": [
          "private",
          "business"
        ],
        "icon": "heart-pulse",
        "position": 6,
        "tagline": "Ātrāka piekļuve ārstiem un izmeklējumiem",
        "summary": "Sedz ģimenes ārsta un speciālistu apmeklējumus, izmeklējumus, zobārstniecību un medikamentus atbilstoši izvēlētajai programmai.",
        "hero": {
          "title": "Veselības apdrošināšana bez gaidīšanas rindās",
          "subtitle": "Veselības polise sedz maksas ārsta vizītes un izmeklējumus, kas valsts sistēmā nozīmē vairāku mēnešu gaidīšanu. Uzņēmumiem tā ir arī viens no populārākajiem darbinieku labumiem.",
          "highlights": [
            "Speciālisti bez ģimenes ārsta nosūtījuma",
            "Programmas privātpersonām un darbinieku grupām",
            "Iespējami zobārstniecības un medikamentu limiti"
          ]
        },
        "benefits": [
          {
            "icon": "stethoscope",
            "title": "Ārstu konsultācijas",
            "description": "Ģimenes ārsts, speciālisti un atkārtotas vizītes maksas klīnikās visā Latvijā."
          },
          {
            "icon": "microscope",
            "title": "Izmeklējumi un diagnostika",
            "description": "Analīzes, ultrasonogrāfija, rentgens un, atkarībā no programmas, arī magnētiskā rezonanse vai datortomogrāfija."
          },
          {
            "icon": "tooth",
            "title": "Zobārstniecība",
            "description": "Parasti ar atsevišķu gada limitu un līdzmaksājumu — sedz higiēnu, plombēšanu un neatliekamo palīdzību."
          },
          {
            "icon": "users",
            "title": "Darbinieku programmas",
            "description": "Uzņēmumiem polise ir ar nodokļu atvieglojumiem noteiktā apmērā un palīdz noturēt darbiniekus."
          }
        ],
        "covered": [
          "Ģimenes ārsta un speciālistu maksas konsultācijas",
          "Laboratoriskie un instrumentālie izmeklējumi",
          "Fizikālā terapija un rehabilitācija programmas ietvaros",
          "Zobārstniecība un profilaktiskā higiēna gada limita ietvaros",
          "Medikamenti un vakcinācija, ja programma to paredz"
        ],
        "not_covered": [
          "Plastiskā ķirurģija un estētiskās procedūras",
          "Ārstēšanās ārzemēs — to sedz ceļojumu polise",
          "Hroniskas slimības ārstēšana, ja tā sākusies pirms polises",
          "Neauglības ārstēšana un mākslīgā apaugļošana",
          "Alternatīvā medicīna ārpus programmas saraksta"
        ],
        "pricing": {
          "intro": "Veselības polises cena atkarīga no programmas apjoma. Uzņēmumiem cena uz vienu darbinieku samazinās, palielinoties grupas lielumam.",
          "examples": [
            {
              "label": "Pamata programma privātpersonai",
              "price": "180–320 € / gadā",
              "note": "Konsultācijas un izmeklējumi"
            },
            {
              "label": "Plaša programma ar zobārstniecību",
              "price": "350–600 € / gadā",
              "note": "Papildu limiti un medikamenti"
            },
            {
              "label": "Uzņēmumam, 15 darbinieki",
              "price": "200–420 € / darbinieku gadā",
              "note": "Cena samazinās lielākām grupām"
            }
          ],
          "factors": [
            "Programmas apjoms un gada limiti",
            "Apdrošināto personu vecums un skaits",
            "Līdzmaksājuma apmērs par vizītēm",
            "Iekļautās klīnikas un pieejamie speciālisti"
          ]
        },
        "faq": [
          {
            "question": "Vai polise sedz ārstēšanos jebkurā klīnikā?",
            "answer": "Segums attiecas uz apdrošinātāja sadarbības klīnikām. Citās iestādēs izdevumus var atgūt pēc rēķina iesniegšanas, bieži daļēji."
          },
          {
            "question": "Vai ir gaidīšanas periods?",
            "answer": "Daļai pakalpojumu, piemēram, zobārstniecībai vai plānveida operācijām, var būt nogaidīšanas periods no viena līdz trim mēnešiem."
          },
          {
            "question": "Vai uzņēmums var apdrošināt tikai daļu darbinieku?",
            "answer": "Var, bet nodokļu atvieglojumi parasti attiecas uz gadījumiem, kad polise pieejama visiem darbiniekiem vienādos nosacījumos."
          },
          {
            "question": "Vai bērnus var iekļaut polisē?",
            "answer": "Jā, ģimenes programmas ir pieejamas gan privātpersonām, gan kā papildinājums darbinieku polisēm par darbinieka līdzmaksājumu."
          },
          {
            "question": "Kas notiek, ja mainu darbu?",
            "answer": "Darba devēja polise beidzas ar darba attiecībām. Bieži ir iespējams turpināt līdzvērtīgu polisi privāti bez jaunas nogaidīšanas."
          }
        ],
        "seo": {
          "title": "Veselības apdrošināšana — programmas un cenas | kreditiem.lv Apdrošināšana",
          "description": "Veselības apdrošināšana privātpersonām un uzņēmumiem: konsultācijas, izmeklējumi, zobārstniecība. Saņemiet piedāvājumu."
        },
        "related": [
          "nelaimes-gadijumu-apdrosinasana",
          "darbinieku-apdrosinasana",
          "celojumu-apdrosinasana"
        ],
        "form_fields": [
          {
            "name": "insured_count",
            "label": "Apdrošināmo personu skaits",
            "type": "number",
            "required": true,
            "placeholder": 1
          },
          {
            "name": "coverage_level",
            "label": "Vēlamā programma",
            "type": "select",
            "required": false,
            "options": [
              "Pamata",
              "Standarta",
              "Plaša",
              "Vēl nezinu"
            ]
          },
          {
            "name": "city",
            "label": "Pilsēta, kurā izmantosiet pakalpojumus",
            "type": "text",
            "required": false,
            "placeholder": "Rīga"
          },
          {
            "name": "extras",
            "label": "Kas ir svarīgs?",
            "type": "multiselect",
            "required": false,
            "options": [
              "Zobārstniecība",
              "Medikamenti",
              "Fizikālā terapija",
              "Optika",
              "Grūtniecības aprūpe",
              "Plānveida operācijas"
            ]
          },
          {
            "name": "budget_per_person",
            "label": "Plānotais budžets uz vienu personu gadā",
            "type": "number",
            "required": false,
            "unit": "€"
          }
        ]
      }
    },
    "blogs": {
      "bonus-malus-sistema": {
        "title": "Kā darbojas Bonus-Malus sistēma",
        "category": "auto",
        "related_product": "octa",
        "author": "Kristīne Liepa, apdrošināšanas brokere",
        "published_at": "2026-02-11",
        "tags": [
          "OCTA",
          "Bonus-Malus"
        ],
        "excerpt": "Bonus-Malus klase var mainīt OCTA cenu vairākas reizes. Skaidrojam, kā klase aug, kā tā krītas pēc negadījuma un ko darīt, ja tā šķiet nepareiza.",
        "seo": {
          "title": "Bonus-Malus klase OCTA — kā tā veidojas un ietekmē cenu",
          "description": "Bonus-Malus ir vadītāja vēstures skala, kas nosaka OCTA cenu. Uzziniet, kā klase aug, cik ātri tā atjaunojas pēc negadījuma un kā to pārbaudīt."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Bonus-Malus ir vienota skala, kas atspoguļo autovadītāja apdrošināšanas vēsturi. Tā nav katra apdrošinātāja iekšēja sistēma — dati ir vienoti, tāpēc klasi nav iespējams \"atstāt\" pie viena apdrošinātāja un sākt no jauna pie cita."
          },
          {
            "type": "heading",
            "text": "Kā klase mainās"
          },
          {
            "type": "paragraph",
            "text": "Par katru gadu, kas nobraukts bez negadījuma, kurā bijāt vainīgais, klase pakāpeniski paaugstinās. Katrs negadījums to samazina, un samazinājums ir straujāks par pieaugumu. Tas nozīmē, ka vienu negadījumu var \"izbraukt\" vairāku gadu laikā."
          },
          {
            "type": "list",
            "items": [
              "Augstāka klase nozīmē zemāku OCTA prēmiju",
              "Klase ir piesaistīta personai, nevis automašīnai",
              "Negadījums bez jūsu vainas klasi nemazina",
              "Klase saglabājas arī tad, ja kādu laiku nav bijis auto"
            ]
          },
          {
            "type": "heading",
            "text": "Cik liela ir cenas atšķirība"
          },
          {
            "type": "paragraph",
            "text": "Starp zemāko un augstāko klasi OCTA cena var atšķirties vairākas reizes. Praksē pieredzējis vadītājs ar labu vēsturi vieglajai automašīnai maksā no 45 līdz 80 eiro gadā, bet vadītājs pēc diviem negadījumiem — no 200 līdz 400 eiro par to pašu automašīnu."
          },
          {
            "type": "heading",
            "text": "Ko darīt, ja klase šķiet nepareiza"
          },
          {
            "type": "paragraph",
            "text": "Klasi aprēķina no reģistrā uzkrātās informācijas, un kļūdas gadās reti, taču mēdz notikt, ja negadījumā vaina nav bijusi jūsu, bet dati ievadīti kā pretēji. Šādā gadījumā vērts lūgt apdrošinātājam paskaidrot aprēķinu. Konsultants var pārbaudīt datus jūsu vietā pirms polises noformēšanas."
          },
          {
            "type": "callout",
            "title": "Nelielu bojājumu gadījumā rēķiniet",
            "text": "Ja negadījumā radīti pavisam nelieli zaudējumi, dažkārt izdevīgāk tos atlīdzināt no saviem līdzekļiem, nevis pieteikt OCTA gadījumu. Kritums klasē var izmaksāt vairāk nekā pats remonts."
          },
          {
            "type": "paragraph",
            "text": "Ja plānojat mainīt automašīnu vai atgriezties pie braukšanas pēc pārtraukuma, pieteikumā norādiet situāciju — pārbaudīsim klasi un sagatavosim piedāvājumu."
          }
        ]
      },
      "celojumu-apdrosinasana-eiropa": {
        "title": "Ceļojumu apdrošināšana Eiropā — ko izvēlēties",
        "category": "celojumi",
        "related_product": "celojumu-apdrosinasana",
        "author": "Līga Bērziņa, apdrošināšanas brokere",
        "published_at": "2026-04-01",
        "tags": [
          "ceļojumi",
          "Eiropa",
          "medicīna"
        ],
        "excerpt": "Braucot uz Eiropu, svarīgākais ir medicīniskā seguma limits un palīdzības dienests. Skaidrojam, kādu segumu izvēlēties un kad pietiek ar gada polisi.",
        "seo": {
          "title": "Ceļojumu apdrošināšana Eiropā — segums, limiti un cenas",
          "description": "Kādu ceļojumu apdrošināšanu izvēlēties braucienam uz Eiropu: medicīniskais limits, bagāža, ceļojuma atcelšana un gada polises izdevīgums."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Ceļojums uz Eiropu šķiet drošs, un lielākā daļa braucienu patiešām paiet bez starpgadījumiem. Tomēr viena diena slimnīcā Vācijā vai Itālijā var izmaksāt vairākus simtus eiro, un neatliekamā operācija — vairākus tūkstošus."
          },
          {
            "type": "heading",
            "text": "Cik liels medicīniskais limits vajadzīgs"
          },
          {
            "type": "paragraph",
            "text": "Eiropas galamērķiem praksē pietiek ar 100 000 eiro medicīnisko limitu. Zemāki limiti, piemēram, 30 000 eiro, izklausās pietiekami, bet nesedz sarežģītākus gadījumus, kur nepieciešama transportēšana atpakaļ uz Latviju ar medicīnisko pavadību."
          },
          {
            "type": "heading",
            "text": "Ko vēl iekļauj polise"
          },
          {
            "type": "list",
            "items": [
              "Bagāžas nozaudēšana, aizkavēšanās vai bojājumi",
              "Ceļojuma atcelšana slimības vai citu pamatotu iemeslu dēļ",
              "Civiltiesiskā atbildība, ja ceļojumā nodarāt zaudējumus citiem",
              "Dokumentu atjaunošana, ja pase vai ID karte nozaudēta",
              "Palīdzība pa telefonu, bieži arī latviešu valodā"
            ]
          },
          {
            "type": "heading",
            "text": "Vienreizēja vai gada polise"
          },
          {
            "type": "paragraph",
            "text": "Ja gadā plānojat vairāk nekā divus braucienus, gada polise gandrīz vienmēr ir lētāka. Tā sedz neierobežotu braucienu skaitu, bet katram braucienam ir maksimālais ilgums — parasti 30 vai 45 dienas. Gada polise ir īpaši ērta tiem, kas bieži brauc darba komandējumos."
          },
          {
            "type": "callout",
            "title": "Nesajauciet ar EVAK karti",
            "text": "Eiropas veselības apdrošināšanas karte dod tiesības uz valsts medicīnas pakalpojumiem tādā pašā apmērā kā vietējiem iedzīvotājiem. Tā nesedz pacienta līdzmaksājumus, privātās klīnikas un transportēšanu mājās."
          },
          {
            "type": "heading",
            "text": "Biežākās kļūdas"
          },
          {
            "type": "list",
            "items": [
              "Polises iegāde tikai dienā, kad sākas brauciens, aizmirstot par ceļu turp",
              "Aktīvās atpūtas neiekļaušana, ja plānota slēpošana vai kalnu pārgājieni",
              "Ceļojuma atcelšanas seguma neiekļaušana dārgiem braucieniem",
              "Hronisku slimību nenorādīšana, kas vēlāk kļūst par atteikuma pamatu"
            ]
          },
          {
            "type": "paragraph",
            "text": "Pieteikumā norādiet galamērķi, datumus un ceļotāju skaitu — sagatavosim vairākus variantus ar atšķirīgiem limitiem, lai varat izvēlēties."
          }
        ]
      },
      "celojumu-apdrosinasana-ziemas-sportam": {
        "title": "Ceļojumu apdrošināšana slēpošanas braucienam",
        "category": "celojumi",
        "related_product": "celojumu-apdrosinasana",
        "author": "Līga Bērziņa, apdrošināšanas brokere",
        "published_at": "2026-04-29",
        "tags": [
          "ceļojumi",
          "sports",
          "slēpošana"
        ],
        "excerpt": "Standarta ceļojumu polise nesedz traumas slēpošanas nogāzē. Skaidrojam, kāds papildu segums nepieciešams ziemas sportam un cik tas maksā.",
        "seo": {
          "title": "Ceļojumu apdrošināšana slēpošanai — kāds segums vajadzīgs",
          "description": "Slēpošanas traumas sedz tikai polise ar ziemas sporta segumu. Uzziniet, ko iekļauj aktīvās atpūtas papildinājums un cik tas izmaksā."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Slēpošanas brauciens ir viens no gadījumiem, kad standarta ceļojumu polise var izrādīties nederīga tieši tajā mirklī, kad tā visvairāk vajadzīga. Iemesls ir vienkāršs: lielākā daļa polišu pamata versijā izslēdz traumas, kas gūtas, nodarbojoties ar ziemas sportu."
          },
          {
            "type": "heading",
            "text": "Kas ir aktīvās atpūtas segums"
          },
          {
            "type": "paragraph",
            "text": "Aktīvās atpūtas jeb sporta papildinājums paplašina medicīnisko segumu uz traumām, kas gūtas noteiktās aktivitātēs. Ziemas sportam tas parasti iekļauj kalnu slēpošanu un snovbordu iezīmētās trasēs, distanču slēpošanu un slidošanu."
          },
          {
            "type": "list",
            "items": [
              "Traumas nogāzē un uz slidotavas",
              "Glābšanas un evakuācijas izmaksas no kalna",
              "Slēpošanas inventāra bojājumi vai zādzība, atkarībā no polises",
              "Neizmantoto slēpošanas abonementa dienu kompensācija dažās polisēs"
            ]
          },
          {
            "type": "heading",
            "text": "Kas paliek ārpus seguma"
          },
          {
            "type": "paragraph",
            "text": "Pat ar sporta papildinājumu ārpus trasēm jeb frīraids bieži netiek segts, tāpat kā sacensības un treniņi profesionālā līmenī. Ja plānojat braukt neiezīmētās nogāzēs, par to jāinformē apdrošinātājs atsevišķi — dažiem tas ir pieejams kā atsevišķs risks."
          },
          {
            "type": "callout",
            "title": "Glābšana kalnos ir dārga",
            "text": "Evakuācija no nogāzes ar ratriku un nogādāšana slimnīcā Alpos var izmaksāt no dažiem simtiem līdz vairākiem tūkstošiem eiro. Šī ir galvenā izmaksu pozīcija, ko sedz sporta papildinājums."
          },
          {
            "type": "heading",
            "text": "Cik tas maksā"
          },
          {
            "type": "paragraph",
            "text": "Ziemas sporta papildinājums parasti palielina polises cenu par 30–80 %. Ja nedēļas polise Eiropā izmaksā 12 eiro, ar sporta segumu tā būs ap 18–22 eiro. Salīdzinot ar slēpošanas brauciena kopējām izmaksām, tā ir maza daļa."
          },
          {
            "type": "heading",
            "text": "Ko pārbaudīt pirms brauciena"
          },
          {
            "type": "list",
            "items": [
              "Vai polisē skaidri norādīts, ka segums attiecas uz kalnu slēpošanu",
              "Vai iekļautas glābšanas un evakuācijas izmaksas",
              "Kāds ir medicīniskais limits — kalnu reģionos rēķini ir augstāki",
              "Vai inventārs ir apdrošināts un ar kādu limitu"
            ]
          },
          {
            "type": "paragraph",
            "text": "Pieteikumā norādiet, ka plānojat ziemas sportu, un piedāvājumā redzēsiet variantus tikai ar atbilstošu segumu."
          }
        ]
      },
      "civiltiesiska-atbildiba-uznemumiem": {
        "title": "Civiltiesiskās atbildības apdrošināšana uzņēmumiem",
        "category": "atbildiba",
        "related_product": "civiltiesiska-atbildiba",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-06-17",
        "tags": [
          "atbildība",
          "uzņēmumiem",
          "riski"
        ],
        "excerpt": "Viena kļūda var izmaksāt vairāk par gada peļņu. Skaidrojam, ko sedz uzņēmuma atbildības polise, kā izvēlēties limitu un kad tā ir obligāta.",
        "seo": {
          "title": "Uzņēmuma civiltiesiskās atbildības apdrošināšana — segums un limiti",
          "description": "Civiltiesiskās atbildības apdrošināšana uzņēmumiem sedz klientiem un trešajām personām nodarītos zaudējumus. Uzziniet, kā izvēlēties limitu."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Uzņēmuma darbība gandrīz vienmēr saskaras ar citu cilvēku mantu un veselību. Apmeklētājs var paslīdēt veikalā, remontstrādnieks var applūdināt klienta dzīvokli, bet no ēkas jumta var nokrist sniegs uz automašīnas. Šādos gadījumos zaudējumus sedz civiltiesiskās atbildības apdrošināšana."
          },
          {
            "type": "heading",
            "text": "Ko polise sedz"
          },
          {
            "type": "list",
            "items": [
              "Trešajām personām nodarīti mantas bojājumi",
              "Kaitējums cilvēku veselībai un ar to saistītie izdevumi",
              "Juridiskās aizstāvības un ekspertīžu izmaksas",
              "Darbinieku pieļautas kļūdas, veicot darba pienākumus",
              "Zaudējumi no pārdotas preces trūkumiem, ja segums iekļauts"
            ]
          },
          {
            "type": "heading",
            "text": "Vispārējā un profesionālā atbildība"
          },
          {
            "type": "paragraph",
            "text": "Vispārējā atbildība attiecas uz fiziskiem bojājumiem — bojāta manta, trauma telpās. Profesionālā atbildība sedz zaudējumus no kļūdas pakalpojumā: nepareizs grāmatvedības aprēķins, projektēšanas kļūda vai kavēta atskaite. Pakalpojumu uzņēmumiem parasti nepieciešamas abas."
          },
          {
            "type": "heading",
            "text": "Kā izvēlēties limitu"
          },
          {
            "type": "paragraph",
            "text": "Limits jāizvēlas nevis pēc apgrozījuma, bet pēc iespējamā zaudējuma apmēra. Ja strādājat ar dārgu klientu mantu vai jūsu kļūda var apturēt cita uzņēmuma darbību, limitam jābūt attiecīgi lielākam."
          },
          {
            "type": "list",
            "items": [
              "Mazam pakalpojumu uzņēmumam — no 25 000 līdz 50 000 eiro",
              "Būvniecībā un ražošanā — no 100 000 eiro",
              "Projektēšanā un konsultācijās — bieži no 200 000 eiro",
              "Publiskajos iepirkumos — limits parasti norādīts nolikumā"
            ]
          },
          {
            "type": "callout",
            "title": "Iepirkumos limitu prasa dokumentāli",
            "text": "Ja piedalāties publiskajos iepirkumos, atbildības polise ar noteiktu limitu bieži ir kvalifikācijas prasība. Apdrošinātājs var izsniegt izziņu, ko pievienot piedāvājumam."
          },
          {
            "type": "heading",
            "text": "Kas netiek segts"
          },
          {
            "type": "list",
            "items": [
              "Līgumsodi, soda naudas un nokavējuma procenti",
              "Paša uzņēmuma īpašuma bojājumi",
              "Apzināta rīcība un rupja neuzmanība",
              "Zaudējumi, kas radušies pirms polises darbības sākuma"
            ]
          },
          {
            "type": "paragraph",
            "text": "Aizpildiet pieteikumu ar darbības aprakstu un apgrozījumu — sagatavosim piedāvājumu ar atbilstošiem limitiem."
          }
        ]
      },
      "evak-karte-vai-celojumu-polise": {
        "title": "EVAK karte vai ceļojumu polise — kas ko sedz",
        "category": "celojumi",
        "related_product": "celojumu-apdrosinasana",
        "author": "Līga Bērziņa, apdrošināšanas brokere",
        "published_at": "2026-04-15",
        "tags": [
          "ceļojumi",
          "EVAK",
          "medicīna"
        ],
        "excerpt": "Eiropas veselības apdrošināšanas karte un ceļojumu polise nav savstarpēji aizvietojamas. Salīdzinām, ko sedz katra un kad vajag abas.",
        "seo": {
          "title": "EVAK karte vai ceļojumu apdrošināšana — kas atšķiras",
          "description": "Ko sedz Eiropas veselības apdrošināšanas karte un ko ceļojumu polise. Kāpēc ar EVAK vien nepietiek un kā tās papildina viena otru."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Pirms brauciena bieži rodas jautājums: ja ir bezmaksas Eiropas veselības apdrošināšanas karte, kāpēc vēl maksāt par polisi? Atbilde ir vienkārša — tās darbojas pēc pilnīgi atšķirīga principa."
          },
          {
            "type": "heading",
            "text": "Ko sedz EVAK karte"
          },
          {
            "type": "paragraph",
            "text": "EVAK karte dod tiesības saņemt valsts apmaksātus medicīnas pakalpojumus tādā pašā apmērā, kā tos saņem attiecīgās valsts iedzīvotāji. Tas nozīmē arī tos pašus līdzmaksājumus un rindas. Ja valstī par vizīti pie ārsta jāmaksā 30 eiro, jums arī būs jāmaksā šie 30 eiro."
          },
          {
            "type": "list",
            "items": [
              "Darbojas Eiropas Savienībā, EEZ valstīs un Šveicē",
              "Attiecas tikai uz valsts, nevis privātajām iestādēm",
              "Nesedz līdzmaksājumus un pacienta iemaksas",
              "Nesedz transportēšanu uz Latviju",
              "Ir bez maksas un derīga vairākus gadus"
            ]
          },
          {
            "type": "heading",
            "text": "Ko sedz ceļojumu polise"
          },
          {
            "type": "paragraph",
            "text": "Ceļojumu polise sedz neatliekamo ārstēšanu arī privātās klīnikās, kas ārzemēs bieži ir vienīgā ātri pieejamā iespēja. Papildus tā sedz repatriāciju, bagāžu, ceļojuma atcelšanu un civiltiesisko atbildību. Būtiska atšķirība ir palīdzības dienests, kas norēķinās ar klīniku tieši, tāpēc jums nav jāmaksā no savas kabatas un pēc tam jācīnās par kompensāciju."
          },
          {
            "type": "heading",
            "text": "Praktiskas atšķirības"
          },
          {
            "type": "list",
            "items": [
              "Vizīte pie ārsta valsts klīnikā: EVAK sedz, ar līdzmaksājumu",
              "Privātā klīnika bez rindas: sedz tikai polise",
              "Transportēšana uz Latviju ar medicīnisko pavadību: sedz tikai polise",
              "Nozaudēta bagāža: sedz tikai polise",
              "Ceļojuma atcelšana slimības dēļ: sedz tikai polise ar attiecīgu segumu"
            ]
          },
          {
            "type": "callout",
            "title": "Ņemiet līdzi abas",
            "text": "Praksē vislabāk darbojas kombinācija: EVAK karte samazina rēķinu valsts iestādēs, bet polise nosedz pārējo. Karti pieprasa Nacionālais veselības dienests, un tā ir bez maksas."
          },
          {
            "type": "paragraph",
            "text": "Ja neesat pārliecināts, kāds segums nepieciešams jūsu braucienam, aizpildiet pieteikumu — sagatavosim piedāvājumu ar atbilstošiem limitiem."
          }
        ]
      },
      "ka-ietaupit-uz-apdrosinasanu": {
        "title": "Kā ietaupīt uz apdrošināšanu, nezaudējot segumu",
        "category": "padomi",
        "author": "Kristīne Liepa, apdrošināšanas brokere",
        "published_at": "2026-08-05",
        "tags": [
          "padomi",
          "cenas",
          "ietaupījums"
        ],
        "excerpt": "Lētākā polise ne vienmēr ir izdevīgākā. Septiņi veidi, kā samazināt prēmiju, saglabājot segumu tiem riskiem, kas patiešām ir svarīgi.",
        "seo": {
          "title": "Kā ietaupīt uz apdrošināšanu — 7 praktiski veidi",
          "description": "Kā samazināt apdrošināšanas izmaksas, nezaudējot svarīgo segumu: pašrisks, polišu apvienošana, gada maksājums un summu pārskatīšana."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Apdrošināšanā ietaupīt var divos veidos: samaksāt mazāk par to pašu segumu vai samaksāt mazāk par mazāku segumu. Pirmais ir saprātīgs, otrais parasti atklājas sliktākajā brīdī. Šie ir veidi, kā palikt pirmajā kategorijā."
          },
          {
            "type": "heading",
            "text": "1. Pārskatiet polisi katru gadu"
          },
          {
            "type": "paragraph",
            "text": "Apdrošinātāju cenu politika mainās, un pagājušajā gadā izdevīgākais vairs nav izdevīgākais šogad. Automātiska polises pagarināšana ir ērta, bet reti lētākā izvēle."
          },
          {
            "type": "heading",
            "text": "2. Izvēlieties pašrisku apzināti"
          },
          {
            "type": "paragraph",
            "text": "Lielāks pašrisks samazina prēmiju. Aprēķiniet summu, ko spējat samaksāt uzreiz, un izvēlieties to. Tā ietaupāt uz maziem gadījumiem, saglabājot aizsardzību pret lieliem."
          },
          {
            "type": "heading",
            "text": "3. Apvienojiet polises"
          },
          {
            "type": "paragraph",
            "text": "OCTA ar KASKO, mājokli ar atbildību, uzņēmuma īpašumu ar darbinieku apdrošināšanu — par vairākām polisēm pie viena apdrošinātāja gandrīz vienmēr ir atlaide."
          },
          {
            "type": "heading",
            "text": "4. Maksājiet par gadu"
          },
          {
            "type": "paragraph",
            "text": "Sadalot maksājumu pa mēnešiem, kopsumma bieži ir par 5–10 % lielāka. Ja naudas plūsma to atļauj, gada maksājums ir vienkāršs ietaupījums."
          },
          {
            "type": "heading",
            "text": "5. Samaziniet risku fiziski"
          },
          {
            "type": "list",
            "items": [
              "Ūdens noplūdes sensori mājoklī",
              "Signalizācija un videonovērošana",
              "Ugunsgrēka atklāšanas sistēma uzņēmuma telpās",
              "Automašīnas glabāšana slēgtā stāvvietā"
            ]
          },
          {
            "type": "heading",
            "text": "6. Pārskatiet apdrošinājuma summas"
          },
          {
            "type": "paragraph",
            "text": "Summas mēdz būt gan par zemām, gan par augstām. Ja apdrošināt tehniku, kuras vairs nav, vai automašīnu par vērtību, kas vairs neatbilst tirgum, maksājat par neko."
          },
          {
            "type": "callout",
            "title": "Nesamaziniet atbildības limitu",
            "text": "Civiltiesiskās atbildības segums ir viena no lētākajām polises daļām, bet tieši tā pasargā no lielākajām summām. Ietaupīt uz tā gandrīz nekad nav izdevīgi."
          },
          {
            "type": "heading",
            "text": "7. Saņemiet piedāvājumu"
          },
          {
            "type": "paragraph",
            "text": "Konsultācija klientam ir bez maksas, jo atlīdzību maksā apdrošinātājs. Aizpildiet pieteikumu, un sagatavosim piedāvājumu, netērējot stundas mājaslapu pārbaudei."
          },
          {
            "type": "paragraph",
            "text": "Aizpildiet pieteikumu, un nosūtīsim apdrošināšanas piedāvājumu — lēmumu pieņemat jūs."
          }
        ]
      },
      "ka-izveleties-octa": {
        "title": "Kā izvēlēties OCTA un nepārmaksāt",
        "category": "auto",
        "related_product": "octa",
        "author": "Kristīne Liepa, apdrošināšanas brokere",
        "published_at": "2026-01-14",
        "tags": [
          "OCTA",
          "auto",
          "cenas"
        ],
        "excerpt": "OCTA segums visiem apdrošinātājiem ir vienāds, bet cena atšķiras pat par 40 %. Skaidrojam, no kā tā veidojas un kā izvēlēties izdevīgāko polisi.",
        "seo": {
          "title": "Kā izvēlēties OCTA 2026. gadā — padomi un cenu skaidrojums",
          "description": "OCTA segumu nosaka likums, tāpēc atšķiras tikai cena. Uzziniet, kas ietekmē OCTA cenu, kā darbojas Bonus-Malus un kā izvēlēties polises termiņu."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "OCTA ir vienīgā obligātā transportlīdzekļa apdrošināšana Latvijā. Tā sedz zaudējumus, ko ar automašīnu nodarāt citiem — otras puses auto remontu, bojātu mantu un cilvēku ārstēšanos. Tā kā seguma apjomu nosaka likums, visos apdrošinātājos tas ir identisks. Atšķiras vienīgi cena un tas, cik ērti polisi noformēt."
          },
          {
            "type": "heading",
            "text": "Kas ietekmē OCTA cenu"
          },
          {
            "type": "paragraph",
            "text": "Apdrošinātāji izmanto savus riska modeļus, tāpēc viena un tā pati automašīna dažādos uzņēmumos var izmaksāt būtiski atšķirīgi. Praksē lielāko ietekmi atstāj šie faktori:"
          },
          {
            "type": "list",
            "items": [
              "Transportlīdzekļa veids, vecums, jauda un pašmasa",
              "Reģistrācijas vieta — Rīgā negadījumu blīvums ir augstāks",
              "Bonus-Malus klase, kas atspoguļo iepriekšējos negadījumus",
              "Polises termiņš — īsa polise izmaksā proporcionāli dārgāk",
              "Vai transportlīdzeklis reģistrēts fiziskai vai juridiskai personai"
            ]
          },
          {
            "type": "heading",
            "text": "Vai vērts izvēlēties īsāku termiņu"
          },
          {
            "type": "paragraph",
            "text": "Mēneša polise sākotnēji izskatās lētāka, bet, pārrēķinot uz gadu, tā izmaksā pat divas reizes vairāk. Īss termiņš ir pamatots tikai tad, ja automašīnu plānojat pārdot vai lietosiet sezonāli. Ja auto lietojat visu gadu, gada polise gandrīz vienmēr ir izdevīgākā."
          },
          {
            "type": "heading",
            "text": "Pievērsiet uzmanību Bonus-Malus klasei"
          },
          {
            "type": "paragraph",
            "text": "Bonus-Malus ir vienota vadītāja vēstures skala. Braucot bez negadījumiem, klase pakāpeniski aug, un cena samazinās. Ja bijāt vainīgais negadījumā, klase krītas un nākamā polise var izmaksāt vairākas reizes dārgāk. Klase ir piesaistīta personai, nevis automašīnai, tāpēc tā saglabājas arī pēc auto maiņas."
          },
          {
            "type": "callout",
            "title": "Praktisks padoms",
            "text": "Pārbaudiet OCTA beigu datumu kalendārā un pieteikieties nedēļu iepriekš. Pēdējā dienā pirktā polise nekad nav lētāka, bet steigā biežāk paliek nepamanītas kļūdas datos."
          },
          {
            "type": "heading",
            "text": "Ko pārbaudīt pirms polises iegādes"
          },
          {
            "type": "list",
            "items": [
              "Vai reģistrācijas numurs un transportlīdzekļa dati ir ievadīti pareizi",
              "Vai polises sākuma datums ir tas, kas nepieciešams",
              "Vai izvēlētais termiņš atbilst plānotajai auto lietošanai",
              "Vai apdrošinātājs ir ērti sasniedzams negadījuma gadījumā"
            ]
          },
          {
            "type": "paragraph",
            "text": "Ja nevēlaties rēķināt polisi pats, aizpildiet vienu pieteikumu — sagatavosim apdrošināšanas piedāvājumu. Konsultācija jums ir bez maksas."
          }
        ]
      },
      "ka-noteikt-apdrosinajuma-summu": {
        "title": "Kā noteikt mājokļa apdrošinājuma summu",
        "category": "majoklis",
        "related_product": "majokla-apdrosinasana",
        "author": "Andris Ozols, apdrošināšanas brokeris",
        "published_at": "2026-03-18",
        "tags": [
          "mājoklis",
          "apdrošinājuma summa",
          "padomi"
        ],
        "excerpt": "Ja apdrošinājuma summa ir par mazu, atlīdzību samazina proporcionāli. Skaidrojam, kā aprēķināt ēkas atjaunošanas vērtību un mantas summu.",
        "seo": {
          "title": "Apdrošinājuma summa mājoklim — kā to aprēķināt pareizi",
          "description": "Nepietiekama apdrošināšana samazina atlīdzību. Uzziniet, kā noteikt ēkas atjaunošanas vērtību, mantas summu un kāpēc summa jāpārskata katru gadu."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Apdrošinājuma summa ir maksimālais apmērs, ko apdrošinātājs izmaksās. Tā ir viena no retajām polises pozīcijām, kur kļūda ir pamanāma tikai pēc apdrošināšanas gadījuma — un tad ir par vēlu."
          },
          {
            "type": "heading",
            "text": "Kas ir nepietiekama apdrošināšana"
          },
          {
            "type": "paragraph",
            "text": "Ja norādītā summa ir zemāka par īpašuma patieso vērtību, apdrošinātājs var samazināt atlīdzību tādā pašā proporcijā. Piemēram, ja māja ir vērta 200 000 eiro, bet apdrošināta par 100 000 eiro, tad par 20 000 eiro zaudējumu var tikt izmaksāta tikai puse. Tas attiecas arī uz nelieliem bojājumiem, ne tikai uz pilnīgu bojāeju."
          },
          {
            "type": "heading",
            "text": "Ēkas atjaunošanas vērtība"
          },
          {
            "type": "paragraph",
            "text": "Ēkai par pamatu ņem atjaunošanas vērtību, nevis tirgus cenu. Atjaunošanas vērtība ir summa, par kādu šodien varētu uzbūvēt līdzvērtīgu ēku tajā pašā vietā. Rīgas centrā tirgus cena var būt daudz augstāka par būvniecības izmaksām, bet lauku reģionā — tieši pretēji."
          },
          {
            "type": "list",
            "items": [
              "Aprēķinam izmanto platību un vidējās būvniecības izmaksas uz kvadrātmetru",
              "Jāiekļauj arī palīgceltnes: garāža, pirts, šķūnis",
              "Jāņem vērā apdares kvalitāte un inženiersistēmas",
              "Būvniecības izmaksas ir mainīgas, tāpēc summa jāpārskata katru gadu"
            ]
          },
          {
            "type": "heading",
            "text": "Mantas summa"
          },
          {
            "type": "paragraph",
            "text": "Mantai visvienkāršākā metode ir iziet pa telpām un aptuveni saskaitīt, cik izmaksātu nopirkt visu no jauna. Lielākā daļa cilvēku šo summu novērtē par zemu, jo neiekļauj apģērbu, virtuves piederumus un sīkāko tehniku. Vidējam trīs istabu dzīvoklim reāla summa bieži ir 10 000–20 000 eiro."
          },
          {
            "type": "callout",
            "title": "Fotografējiet vērtīgākās lietas",
            "text": "Uzņemiet fotoattēlus un saglabājiet rēķinus par dārgāko tehniku, velosipēdiem un instrumentiem. Tas ievērojami paātrina atlīdzības procesu un novērš strīdus par lietu vecumu."
          },
          {
            "type": "heading",
            "text": "Kad summa jāmaina"
          },
          {
            "type": "list",
            "items": [
              "Pēc remonta vai apdares nomaiņas",
              "Pēc palīgceltnes uzbūvēšanas vai saules paneļu uzstādīšanas",
              "Pēc lielāku iekārtu vai mēbeļu iegādes",
              "Katrā polises atjaunošanas reizē, ņemot vērā izmaksu pieaugumu"
            ]
          },
          {
            "type": "paragraph",
            "text": "Ja nevēlaties rēķināt pats, aizpildiet pieteikumu ar aptuveniem datiem. Konsultants pārbaudīs, vai summa ir reāla, un sagatavos piedāvājumu."
          }
        ]
      },
      "ka-pieteikt-atlidzibu": {
        "title": "Kā pieteikt apdrošināšanas atlīdzību",
        "category": "atlidzibas",
        "author": "Andris Ozols, apdrošināšanas brokeris",
        "published_at": "2026-07-22",
        "tags": [
          "atlīdzības",
          "dokumenti",
          "padomi"
        ],
        "excerpt": "Atlīdzības process ir vienkāršs, ja pirmajās stundās izdarīts pareizais. Soli pa solim par pieteikšanu, dokumentiem un termiņiem.",
        "seo": {
          "title": "Kā pieteikt apdrošināšanas atlīdzību — soļi un dokumenti",
          "description": "Kā rīkoties pēc apdrošināšanas gadījuma: ko fiksēt, kādus dokumentus sagatavot, kādos termiņos pieteikt un ko nedarīt."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Atlīdzības saņemšanu visvairāk ietekmē nevis polises teksts, bet gan tas, kas izdarīts pirmajās stundās pēc notikuma. Vairums atteikumu un samazinājumu rodas nevis ļauna nodoma dēļ, bet tāpēc, ka nav pierādījumu."
          },
          {
            "type": "heading",
            "text": "Pirmie soļi notikuma vietā"
          },
          {
            "type": "list",
            "items": [
              "Novērsiet turpmākus bojājumus, ja to var izdarīt droši",
              "Nofotografējiet situāciju no vairākiem rakursiem, pirms kaut ko pārvietojat",
              "Izsauciet dienestus, ja tas nepieciešams — policiju, ugunsdzēsējus, apsaimniekotāju",
              "Pierakstiet laiku, apstākļus un aculiecinieku kontaktus",
              "Nesāciet remontu, pirms apdrošinātājs bojājumus ir apskatījis vai atļāvis"
            ]
          },
          {
            "type": "heading",
            "text": "Kādos termiņos jāpiesaka"
          },
          {
            "type": "paragraph",
            "text": "Vairums polišu paredz pieteikšanu dažu darba dienu laikā no notikuma vai no brīža, kad par to uzzinājāt. Ceļu satiksmes negadījumiem un zādzībām termiņi parasti ir īsāki. Ja termiņu nokavējat pamatota iemesla dēļ, piemēram, slimnīcā, to vajag paskaidrot rakstiski."
          },
          {
            "type": "heading",
            "text": "Dokumenti, kas parasti nepieciešami"
          },
          {
            "type": "list",
            "items": [
              "Pieteikums apdrošinātāja formā",
              "Fotoattēli un bojājumu apraksts",
              "Dienestu izziņa vai protokols, ja tas ir sastādīts",
              "Rēķini, čeki vai garantijas dokumenti bojātajām lietām",
              "Remonta izmaksu tāme, ja tā jau sagatavota"
            ]
          },
          {
            "type": "callout",
            "title": "Nemetiet ārā bojātās lietas",
            "text": "Bojātā tehnika, mēbeles vai apģērbs ir pierādījums. Ja tās jau izmestas, apdrošinātājam nav ko novērtēt, un atlīdzība var tikt samazināta."
          },
          {
            "type": "heading",
            "text": "Kā paātrināt procesu"
          },
          {
            "type": "paragraph",
            "text": "Iesniedziet visus dokumentus vienā reizē, nevis pa daļām — katrs papildu pieprasījums pagarina termiņu. Ja apdrošinātājs lūdz precizējumus, atbildiet rakstiski un saglabājiet sarakstes kopiju."
          },
          {
            "type": "heading",
            "text": "Ja lēmums nešķiet pamatots"
          },
          {
            "type": "paragraph",
            "text": "Vispirms lūdziet rakstisku pamatojumu ar atsauci uz polises punktu. Bieži izrādās, ka trūkst kāda dokumenta vai nav pareizi saprasti apstākļi. Ja tas nepalīdz, var vērsties pie apdrošinātāja sūdzību izskatītāja un pēc tam pie ombuda. Mūsu klienti šo saraksti var uzticēt konsultantam."
          },
          {
            "type": "paragraph",
            "text": "Ja polise ir noformēta caur mums, atlīdzības jautājumos varat rakstīt vai zvanīt — palīdzēsim sagatavot dokumentus un sazināties ar apdrošinātāju."
          }
        ]
      },
      "kapec-atsaka-atlidzibu": {
        "title": "Kāpēc atsaka apdrošināšanas atlīdzību",
        "category": "atlidzibas",
        "author": "Andris Ozols, apdrošināšanas brokeris",
        "published_at": "2026-07-29",
        "tags": [
          "atlīdzības",
          "izņēmumi",
          "padomi"
        ],
        "excerpt": "Lielākā daļa atteikumu ir paredzami jau polises noformēšanas brīdī. Apkopojam biežākos iemeslus un to, kā no tiem izvairīties.",
        "seo": {
          "title": "Biežākie apdrošināšanas atlīdzības atteikuma iemesli",
          "description": "Kāpēc apdrošinātāji atsaka atlīdzību: nolietojums, izņēmumi, nepatiesa informācija, nepietiekama apdrošināšana un termiņu nokavējums."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Atteikums parasti nav pārsteigums apdrošinātājam — tas izriet no polises nosacījumiem, kurus klients nav izlasījis. Zinot biežākos iemeslus, lielāko daļu situāciju var novērst jau pirms polises parakstīšanas."
          },
          {
            "type": "heading",
            "text": "1. Notikums nav apdrošināšanas gadījums"
          },
          {
            "type": "paragraph",
            "text": "Apdrošināšana sedz pēkšņus un neparedzētus notikumus. Pakāpeniska nolietošanās, pelējums, korozija un nolietoti inženiertīkli tādi nav. Tas ir biežākais atteikuma pamats mājokļa apdrošināšanā."
          },
          {
            "type": "heading",
            "text": "2. Risks nav iekļauts polisē"
          },
          {
            "type": "paragraph",
            "text": "Piemēram, KASKO bez riepu seguma nesedz bedrē bojātu disku, bet ceļojumu polise bez sporta papildinājuma nesedz slēpošanas traumu. Šeit palīdz tikai viens: pirms iegādes pārbaudīt, vai jūsu tipiskākie riski ir sarakstā."
          },
          {
            "type": "heading",
            "text": "3. Nepilnīga vai nepatiesa informācija"
          },
          {
            "type": "paragraph",
            "text": "Ja pieteikumā nav norādīts, ka dzīvoklis tiek izīrēts, ēka ilgstoši nav apdzīvota vai uzņēmumam jau bijušas atlīdzības, apdrošinātājs var atteikt. Informācijas neuzrādīšana ir viens no retajiem gadījumiem, kad polise var izrādīties nederīga pilnībā."
          },
          {
            "type": "heading",
            "text": "4. Nepietiekama apdrošināšana"
          },
          {
            "type": "paragraph",
            "text": "Tas nav pilnīgs atteikums, bet atlīdzības samazinājums. Ja īpašums apdrošināts par pusi no patiesās vērtības, arī atlīdzība var tikt samazināta uz pusi — arī tad, ja zaudējums ir neliels."
          },
          {
            "type": "heading",
            "text": "5. Nokavēts pieteikšanas termiņš"
          },
          {
            "type": "paragraph",
            "text": "Vairums polišu paredz pieteikšanu dažu dienu laikā. Vēlāks pieteikums pats par sevi nav pamats atteikumam, ja bojājumus vēl var novērtēt, taču praksē tas ievērojami sarežģī procesu."
          },
          {
            "type": "callout",
            "title": "Ko darīt, ja saņemts atteikums",
            "text": "Lūdziet rakstisku pamatojumu ar norādi uz konkrētu polises punktu. Ļoti bieži izrādās, ka trūkst viena dokumenta vai apstākļi nav pareizi saprasti, un pēc papildu informācijas lēmumu pārskata."
          },
          {
            "type": "heading",
            "text": "Kā samazināt risku jau sākumā"
          },
          {
            "type": "list",
            "items": [
              "Izlasiet izņēmumu sadaļu, nevis tikai seguma sarakstu",
              "Norādiet visu būtisko informāciju, arī to, kas šķiet neizdevīga",
              "Pārskatiet apdrošinājuma summas katru gadu",
              "Saglabājiet rēķinus un fotoattēlus vērtīgākajām lietām",
              "Uzdodiet jautājumus konsultantam pirms parakstīšanas, nevis pēc gadījuma"
            ]
          },
          {
            "type": "paragraph",
            "text": "Ja neesat pārliecināts, vai jūsu situācija ir segta, aizpildiet pieteikumu un aprakstiet to komentāros — pārbaudīsim nosacījumus pirms polises izvēles."
          }
        ]
      },
      "kasko-vai-octa": {
        "title": "KASKO vai OCTA — ar ko tās atšķiras",
        "category": "auto",
        "related_product": "kasko",
        "author": "Kristīne Liepa, apdrošināšanas brokere",
        "published_at": "2026-01-28",
        "tags": [
          "KASKO",
          "OCTA",
          "auto"
        ],
        "excerpt": "OCTA sedz citiem nodarītos zaudējumus, KASKO — jūsu paša automašīnu. Skaidrojam atšķirības, kad KASKO ir obligāta un kā izvēlēties pašrisku.",
        "seo": {
          "title": "KASKO vai OCTA — atšķirības, segums un kad vajag abas",
          "description": "OCTA ir obligāta un sedz citiem nodarītos zaudējumus. KASKO ir brīvprātīga un sedz jūsu auto. Uzziniet, kad nepieciešamas abas polises."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Jautājums \"KASKO vai OCTA\" patiesībā nav izvēle starp diviem variantiem. OCTA ir obligāta visiem, kas brauc ar automašīnu, bet KASKO ir brīvprātīga papildu polise. Tās sedz pilnīgi dažādas situācijas, un daudziem autovadītājiem ir jēga abām."
          },
          {
            "type": "heading",
            "text": "OCTA — zaudējumi citiem"
          },
          {
            "type": "paragraph",
            "text": "Ja izraisāt negadījumu, OCTA atlīdzina otras puses automašīnas remontu, bojāto mantu un cietušo ārstēšanos. Jūsu paša automašīnas bojājumus tā nesedz. Seguma apjomu nosaka likums, tāpēc visos apdrošinātājos tas ir vienāds."
          },
          {
            "type": "heading",
            "text": "KASKO — jūsu paša automašīna"
          },
          {
            "type": "paragraph",
            "text": "KASKO sedz jūsu auto neatkarīgi no tā, kurš negadījumā bija vainīgais. Tā darbojas arī tad, ja nav otras puses: iebraucāt bedrē, uz auto uzkrita koks, salonā izcēlās ugunsgrēks vai automašīnu nozaga."
          },
          {
            "type": "list",
            "items": [
              "Sadursme ar citu auto, šķērsli vai dzīvnieku",
              "Zādzība un vandālisms",
              "Ugunsgrēks un sprādziens",
              "Krusa, vētra, plūdi un uzkrituši koki",
              "Stiklu bojājumi, atkarībā no polises nosacījumiem"
            ]
          },
          {
            "type": "heading",
            "text": "Kad KASKO ir praktiski obligāta"
          },
          {
            "type": "paragraph",
            "text": "Ja automašīna iegādāta līzingā vai ar kredītu, finansētājs gandrīz vienmēr pieprasa KASKO visu līguma laiku. Tas ir loģiski: līdz pēdējam maksājumam auto ir arī līzinga devēja nodrošinājums. Bez finansējuma lēmums ir jūsu, un to visbiežāk nosaka automašīnas vērtība. Praksē KASKO ir vērts autoparkam, kura remonts pārsniegtu vairāku mēnešu ģimenes budžetu."
          },
          {
            "type": "heading",
            "text": "Kā izvēlēties pašrisku"
          },
          {
            "type": "paragraph",
            "text": "Pašrisks ir summa, ko katrā gadījumā maksājat jūs. Jo lielāks pašrisks, jo zemāka prēmija. Izvēloties, aprēķiniet, kādu summu spējat samaksāt uzreiz, nevis kāda prēmija izskatās vislētāk. 400 eiro pašrisks var ietaupīt gadā 70 eiro, bet negadījumā tas nozīmē divreiz lielāku izdevumu."
          },
          {
            "type": "callout",
            "title": "Kopā ir lētāk",
            "text": "Lielākā daļa apdrošinātāju piedāvā atlaidi, ja OCTA un KASKO noformējat vienā vietā. Pieteikumā norādiet, ka nepieciešamas abas — sagatavosim kopēju piedāvājumu."
          },
          {
            "type": "paragraph",
            "text": "KASKO nosacījumi atšķiras vairāk nekā cena. Svarīgi ir ne tikai prēmija, bet arī tas, kas patiesībā ir iekļauts — riepas, aizvietojošais auto, stikli bez pašriska. Aizpildiet pieteikumu, un palīdzēsim izvēlēties piemērotu segumu."
          }
        ]
      },
      "ko-sedz-majokla-apdrosinasana": {
        "title": "Ko sedz mājokļa apdrošināšana",
        "category": "majoklis",
        "related_product": "majokla-apdrosinasana",
        "author": "Andris Ozols, apdrošināšanas brokeris",
        "published_at": "2026-02-25",
        "tags": [
          "mājoklis",
          "īpašums",
          "segums"
        ],
        "excerpt": "Mājokļa polise sastāv no trim daļām — ēkas, apdares un mantas. Skaidrojam, ko katra no tām nozīmē un kuri gadījumi paliek ārpus seguma.",
        "seo": {
          "title": "Ko sedz mājokļa apdrošināšana — segums un izņēmumi",
          "description": "Mājokļa apdrošināšana sedz ēku, apdari un mājsaimniecības mantu. Uzziniet, kādi riski ir iekļauti, kas netiek segts un kā izvēlēties pareizo summu."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Mājokļa apdrošināšana bieži tiek uzskatīta par vienu produktu, bet patiesībā tā sastāv no vairākām daļām, kuras var apdrošināt gan kopā, gan atsevišķi. Saprotot šo dalījumu, ir vieglāk izvēlēties piedāvājumu un pamanīt, kur segums ir par mazu."
          },
          {
            "type": "heading",
            "text": "Trīs polises daļas"
          },
          {
            "type": "list",
            "items": [
              "Ēka: sienas, jumts, pamati, kā arī garāža, pirts vai žogs, ja tie norādīti",
              "Apdare: grīdas, sienu segumi, iebūvētās mēbeles, santehnika un durvis",
              "Manta: mēbeles, tehnika, apģērbs, elektronika un citas ikdienas lietas"
            ]
          },
          {
            "type": "heading",
            "text": "Biežākie apdrošināšanas gadījumi"
          },
          {
            "type": "paragraph",
            "text": "Pretēji izplatītam uzskatam, visbiežākais gadījums mājoklī nav ugunsgrēks, bet gan ūdens noplūde. Pārplīsusi caurule, bojāts boilers vai aizmirsts atvērts krāns rada bojājumus, kuru novēršana viegli izmaksā vairākus tūkstošus eiro, īpaši, ja ūdens nonāk pie kaimiņiem."
          },
          {
            "type": "list",
            "items": [
              "Ūdens noplūde no iekšējiem tīkliem",
              "Ugunsgrēks, dūmi un sprādziens",
              "Vētra, krusa un sniega slodze uz jumta",
              "Zādzība ar ielaušanos un vandālisms",
              "Zibens spēriens un sprieguma svārstības, kas bojā tehniku"
            ]
          },
          {
            "type": "heading",
            "text": "Kas parasti netiek segts"
          },
          {
            "type": "paragraph",
            "text": "Apdrošināšana sedz pēkšņus un neparedzētus notikumus, nevis pakāpenisku nolietošanos. Tāpēc ārpus seguma paliek pelējums, kas veidojies gadiem, nolietoti inženiertīkli, būvniecības kļūdas un remonta laikā radīti bojājumi, ja par tiem nav atsevišķas vienošanās."
          },
          {
            "type": "callout",
            "title": "Atbildība pret kaimiņiem ir svarīga",
            "text": "Iekļaujiet polisē civiltiesisko atbildību. Ja no jūsu mājokļa noplūdis ūdens un bojāta kaimiņa apdare, šī polises daļa atlīdzina viņa zaudējumus — bez tās maksāt nāktos no savas kabatas."
          },
          {
            "type": "heading",
            "text": "Kā izvēlēties apdrošinājuma summu"
          },
          {
            "type": "paragraph",
            "text": "Ēkai par pamatu ņem atjaunošanas vērtību, tas ir, cik izmaksātu uzbūvēt līdzvērtīgu māju šodien. Būvniecības izmaksas pēdējos gados ir augušas, tāpēc pirms polises atjaunošanas summu ir vērts pārrēķināt. Mantai visvienkāršāk ir iziet pa telpām un aptuveni saskaitīt, cik izmaksātu nopirkt visu no jauna."
          },
          {
            "type": "paragraph",
            "text": "Ja neesat pārliecināts par summām, aizpildiet pieteikumu — palīdzēsim aprēķināt segumu un sagatavosim piedāvājumu."
          }
        ]
      },
      "komercipasuma-apdrosinasana-noliktavai": {
        "title": "Noliktavas apdrošināšana — uz ko skatīties",
        "category": "uznemumiem",
        "related_product": "komercipasuma-apdrosinasana",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-07-08",
        "tags": [
          "uzņēmumiem",
          "komercīpašums",
          "noliktava"
        ],
        "excerpt": "Noliktavā risks nav tikai preces, bet arī apstājusies darbība. Skaidrojam, kā noteikt krājumu summu un kāpēc svarīgs pārtraukuma segums.",
        "seo": {
          "title": "Noliktavas un komercīpašuma apdrošināšana — praktiski padomi",
          "description": "Kā apdrošināt noliktavu: krājumu summas noteikšana, ugunsdrošības prasības, darbības pārtraukuma segums un nomnieka atbildība."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Noliktava ir viens no tiem objektiem, kur zaudējums reti aprobežojas ar bojātu īpašumu. Ja preces nav pieejamas, apstājas pārdošana, un klienti aiziet pie konkurentiem. Tāpēc noliktavas polisē vismaz tikpat svarīgs kā īpašuma segums ir darbības pārtraukuma segums."
          },
          {
            "type": "heading",
            "text": "Kā noteikt krājumu summu"
          },
          {
            "type": "paragraph",
            "text": "Krājumus visbiežāk apdrošina pēc vidējā atlikuma gada laikā. Sezonālā biznesā tas ir bīstami: ja decembrī noliktavā ir divreiz vairāk preču nekā vidēji, tad tieši augstākajā punktā segums būs par mazu. Šādos gadījumos norāda maksimālo atlikumu vai izmanto polisi ar deklarēšanu."
          },
          {
            "type": "list",
            "items": [
              "Vidējais atlikums — lētāk, bet riskanti sezonalitātes gadījumā",
              "Maksimālais atlikums — dārgāk, bet paredzams",
              "Deklarējamā polise — summu precizē periodiski pēc faktiskā atlikuma"
            ]
          },
          {
            "type": "heading",
            "text": "Ugunsdrošība ietekmē cenu vairāk par visu"
          },
          {
            "type": "paragraph",
            "text": "Noliktavās prēmiju visvairāk ietekmē ugunsgrēka risks. Automātiskā atklāšanas sistēma, sprinkleri, ugunsdrošas starpsienas un kārtība preču izvietojumā var samazināt prēmiju vairākas reizes. Dažiem preču veidiem, piemēram, plastmasai vai aerosoliem, apdrošinātāji izvirza atsevišķas prasības."
          },
          {
            "type": "heading",
            "text": "Nomnieks vai īpašnieks"
          },
          {
            "type": "paragraph",
            "text": "Ja telpas nomājat, ēkas konstrukcijas parasti apdrošina īpašnieks, bet jūs apdrošināt savu apdari, iekārtas, krājumus un atbildību. Nomas līgumā bieži ir noteikts konkrēts segums un limits — to vērts pārbaudīt pirms polises, lai nesanāk maksāt divreiz par to pašu."
          },
          {
            "type": "callout",
            "title": "Pārtraukuma periodu izvēlē neesiet optimists",
            "text": "Darbības pārtraukuma segumam izvēlas periodu no trim līdz divpadsmit mēnešiem. Praksē telpu atjaunošana pēc nopietna ugunsgrēka reti ir īsāka par sešiem mēnešiem, ieskaitot dokumentu kārtošanu."
          },
          {
            "type": "heading",
            "text": "Ko sagatavot piedāvājumam"
          },
          {
            "type": "list",
            "items": [
              "Adrese, platība un ēkas konstrukcijas materiāls",
              "Uzglabājamo preču veids un vidējā vērtība",
              "Ugunsdrošības un apsardzes risinājumi",
              "Nomas līguma prasības, ja telpas tiek nomātas"
            ]
          },
          {
            "type": "paragraph",
            "text": "Aizpildiet pieteikumu ar šo informāciju — jo precīzāki dati, jo mazāk mainīsies cena galīgajā piedāvājumā."
          }
        ]
      },
      "kravu-apdrosinasana-vai-pietiek-ar-parvadataju": {
        "title": "Vai pietiek ar pārvadātāja atbildību",
        "category": "uznemumiem",
        "related_product": "kravu-apdrosinasana",
        "author": "Roberts Krastiņš, kravu apdrošināšanas brokeris",
        "published_at": "2026-07-15",
        "tags": [
          "kravas",
          "loģistika",
          "atbildība"
        ],
        "excerpt": "Pārvadātāja atbildība ir ierobežota ar kravas svaru, nevis vērtību. Rādām ar aprēķinu, kāpēc dārgai kravai tas var nozīmēt daļēju atlīdzību.",
        "seo": {
          "title": "Kravu apdrošināšana vai pārvadātāja atbildība — kas sedz vairāk",
          "description": "Pārvadātāja atbildība ir ierobežota pēc kravas svara. Uzziniet, kad nepieciešama atsevišķa kravu apdrošināšana un kā aprēķināt segumu."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Nosūtot preces, bieži pietiek ar pārvadātāja apliecinājumu, ka viņam ir apdrošināta atbildība. Problēma ir tā, ka pārvadātāja atbildība un kravas apdrošināšana sedz dažādas summas."
          },
          {
            "type": "heading",
            "text": "Kā aprēķina pārvadātāja atbildību"
          },
          {
            "type": "paragraph",
            "text": "Starptautiskajos autopārvadājumos atbildība ir ierobežota ar konvencijā noteiktu summu par katru bojātās kravas kilogramu. Tas nozīmē, ka atlīdzība atkarīga no svara, nevis no preces vērtības."
          },
          {
            "type": "callout",
            "title": "Piemērs ar skaitļiem",
            "text": "Palete ar elektroniku sver 200 kg un ir vērta 40 000 eiro. Ja atbildības limits ir ap 10 eiro par kilogramu, maksimālā atlīdzība ir aptuveni 2 000 eiro. Atlikušos 38 000 eiro sedz tikai kravas apdrošināšana."
          },
          {
            "type": "heading",
            "text": "Kad kravas polise ir nepieciešama"
          },
          {
            "type": "list",
            "items": [
              "Krava ir dārga, bet viegla — elektronika, medikamenti, precīzijas iekārtas",
              "Maršrutā ir vairākas pārkraušanas vai mainās transporta veids",
              "Prece tiek vesta no attālākiem reģioniem ar jūras transportu",
              "Pircējs vai banka pieprasa apdrošināšanas apliecinājumu",
              "Uzņēmums nespētu izturēt viena sūtījuma zaudējumu"
            ]
          },
          {
            "type": "heading",
            "text": "Ko sedz kravas polise"
          },
          {
            "type": "paragraph",
            "text": "Atlīdzību aprēķina no kravas rēķina vērtības, kam var pievienot transporta izmaksas un plānoto peļņu. Segums darbojas neatkarīgi no pārvadātāja vainas, tāpēc nav jāpierāda, ka bojājums radies viņa nolaidības dēļ."
          },
          {
            "type": "heading",
            "text": "Biežākie atteikumu iemesli"
          },
          {
            "type": "list",
            "items": [
              "Nepiemērots vai nepietiekams iepakojums",
              "Bojājumi nav fiksēti pieņemšanas dokumentos",
              "Temperatūras režīma pārkāpums bez attiecīga seguma",
              "Krava nav atbildusi deklarētajam saturam"
            ]
          },
          {
            "type": "heading",
            "text": "Vienreizēja vai gada polise"
          },
          {
            "type": "paragraph",
            "text": "Ja pārvadājumi ir regulāri, gada polise ar apgrozījuma deklarēšanu izmaksā mazāk nekā atsevišķas polises katram sūtījumam un neprasa administrēšanu pirms katra brauciena."
          },
          {
            "type": "paragraph",
            "text": "Norādiet pieteikumā kravas veidu, maršrutus un aptuveno gada apgrozījumu — sagatavosim gan vienreizēju, gan gada polises piedāvājumu."
          }
        ]
      },
      "nelaimes-gadijumu-apdrosinasana-berniem": {
        "title": "Nelaimes gadījumu apdrošināšana bērniem",
        "category": "veseliba",
        "related_product": "nelaimes-gadijumu-apdrosinasana",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-06-03",
        "tags": [
          "bērni",
          "nelaimes gadījumi",
          "ģimenei"
        ],
        "excerpt": "Bērnu traumas visbiežāk notiek skolā, treniņos un nometnēs. Skaidrojam, kā darbojas bērnu polise, cik tā maksā un kāda summa ir pietiekama.",
        "seo": {
          "title": "Nelaimes gadījumu apdrošināšana bērniem — segums un cenas",
          "description": "Bērnu nelaimes gadījumu apdrošināšana sedz traumas skolā, sportā un brīvajā laikā. Uzziniet, kā izvēlēties summu un ko pārbaudīt polisē."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Bērnu traumas ir statistiski biežākas nekā pieaugušajiem, un tās notiek ikdienišķās situācijās — sporta stundā, treniņā, rotaļu laukumā vai nometnē. Nelaimes gadījumu polise šādos gadījumos izmaksā naudas summu, ko var izlietot pēc saviem ieskatiem."
          },
          {
            "type": "heading",
            "text": "Kā tā atšķiras no veselības polises"
          },
          {
            "type": "paragraph",
            "text": "Veselības apdrošināšana apmaksā ārstu un izmeklējumus. Nelaimes gadījumu polise izmaksā fiksētu summu par traumas sekām neatkarīgi no faktiskajām ārstēšanās izmaksām. Praksē tas palīdz nosegt vecāku darbnespēju, taksometrus uz procedūrām un citas izmaksas, kuras neviens rēķins neatspoguļo."
          },
          {
            "type": "heading",
            "text": "Ko sedz bērnu polise"
          },
          {
            "type": "list",
            "items": [
              "Kaulu lūzumi, izmežģījumi un sasitumi",
              "Apdegumi un traumas mājas apstākļos",
              "Traumas sporta stundās un treniņos",
              "Traumas nometnēs un ekskursijās",
              "Paliekošas sekas un invaliditāte"
            ]
          },
          {
            "type": "heading",
            "text": "Kāda summa ir pietiekama"
          },
          {
            "type": "paragraph",
            "text": "Bērniem visbiežāk izvēlas 5 000–15 000 eiro apdrošinājuma summu. Svarīgi atcerēties, ka izmaksa par konkrētu traumu ir procents no šīs summas atbilstoši polises tabulai. Piemēram, par roku lūzumu var izmaksāt dažus procentus, tāpēc pārāk maza summa nozīmē arī simbolisku atlīdzību."
          },
          {
            "type": "callout",
            "title": "Segums 24 stundas diennaktī",
            "text": "Pārbaudiet, vai polise darbojas visu diennakti, ne tikai mācību laikā. Skolas apdrošināšana dažkārt sedz tikai stundu laiku un ceļu uz skolu."
          },
          {
            "type": "heading",
            "text": "Sports un aktivitātes",
            "level": 3
          },
          {
            "type": "paragraph",
            "text": "Amatieru sportu standarta polise parasti sedz. Cīņas sportu, motosportu un dalību sacensībās nepieciešams norādīt atsevišķi. Ja bērns nodarbojas sporta skolā, to vienmēr ir vērts pieminēt pieteikumā, lai vēlāk nerodas strīds par seguma apjomu."
          },
          {
            "type": "heading",
            "text": "Cik tas izmaksā"
          },
          {
            "type": "paragraph",
            "text": "Bērnu polise ir viena no lētākajām apdrošināšanas formām — bieži 20–50 eiro gadā par 10 000 eiro segumu. Ģimenes polisē vairākiem bērniem cena uz vienu bērnu parasti ir vēl zemāka."
          },
          {
            "type": "paragraph",
            "text": "Aizpildiet pieteikumu, norādot bērnu skaitu un sporta veidus, un saņemsiet apdrošināšanas piedāvājumu."
          }
        ]
      },
      "pasrisks-ka-izveleties": {
        "title": "Pašrisks — kā izvēlēties pareizo",
        "category": "padomi",
        "author": "Kristīne Liepa, apdrošināšanas brokere",
        "published_at": "2026-08-08",
        "tags": [
          "padomi",
          "pašrisks",
          "cenas"
        ],
        "excerpt": "Pašrisks ir vienkāršākais veids, kā ietekmēt polises cenu. Rādām ar aprēķinu, kad lielāks pašrisks atmaksājas un kad tas ir slikta izvēle.",
        "seo": {
          "title": "Kas ir pašrisks apdrošināšanā un kā to izvēlēties",
          "description": "Pašrisks ir summa, ko maksājat pats katrā gadījumā. Uzziniet, kā tas ietekmē prēmiju un kā izvēlēties izdevīgāko variantu."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Pašrisks ir summa, ko katrā apdrošināšanas gadījumā samaksājat jūs. Ja remonts izmaksā 1 200 eiro un pašrisks ir 200 eiro, apdrošinātājs izmaksā 1 000 eiro. Jo lielāks pašrisks, jo zemāka polises prēmija."
          },
          {
            "type": "heading",
            "text": "Kā to izmantot savā labā"
          },
          {
            "type": "paragraph",
            "text": "Apdrošināšanas jēga ir pasargāt no zaudējumiem, ko nespējat samaksāt pats. Nelielus izdevumus vairums mājsaimniecību un uzņēmumu var nosegt no saviem līdzekļiem, tāpēc ir loģiski par tiem nemaksāt prēmijā."
          },
          {
            "type": "callout",
            "title": "Vienkāršs aprēķins",
            "text": "Ja pašriska palielināšana no 150 uz 400 eiro ietaupa 80 eiro gadā, tad pēc trim gadiem bez gadījumiem esat ietaupījis 240 eiro — vairāk nekā papildu 250 eiro, kas jāmaksā vienā gadījumā."
          },
          {
            "type": "heading",
            "text": "Kad lielāks pašrisks ir slikta izvēle"
          },
          {
            "type": "list",
            "items": [
              "Ja jums nav uzkrājuma, no kura to samaksāt uzreiz",
              "Ja gadījumi ir bijuši bieži, piemēram, stiklu bojājumi",
              "Ja pašrisks tiek piemērots katram objektam atsevišķi",
              "Ja līzinga vai nomas līgums nosaka maksimālo pašrisku"
            ]
          },
          {
            "type": "heading",
            "text": "Uzmanieties no pašriska veida"
          },
          {
            "type": "paragraph",
            "text": "Pašrisks var būt fiksēta summa vai procents no zaudējuma, un dažās polisēs — abi, izvēloties lielāko. Uzņēmumu polisēs procentuālais pašrisks lielā zaudējumā nozīmē ievērojamu summu, tāpēc to vērts pārbaudīt atsevišķi."
          },
          {
            "type": "heading",
            "text": "Kur pašriska nav"
          },
          {
            "type": "paragraph",
            "text": "OCTA gadījumā cietušajam pašrisks netiek piemērots. Vairākos KASKO piedāvājumos stiklu maiņa ir bez pašriska, un veselības polisēs tā vietā darbojas līdzmaksājums par katru vizīti."
          },
          {
            "type": "paragraph",
            "text": "Ja neesat pārliecināts, kāds pašrisks jums ir izdevīgākais, pieteikumā to norādiet — sagatavosim piedāvājumu un parādīsim, kā pašrisks ietekmē prēmiju."
          }
        ]
      },
      "profesionala-atbildiba-pakalpojumiem": {
        "title": "Profesionālā atbildība pakalpojumu sniedzējiem",
        "category": "atbildiba",
        "related_product": "civiltiesiska-atbildiba",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-06-24",
        "tags": [
          "atbildība",
          "profesionālā atbildība",
          "pakalpojumi"
        ],
        "excerpt": "Grāmatvedim, projektētājam vai IT uzņēmumam lielākais risks nav bojāta manta, bet kļūda darbā. Skaidrojam, kā to apdrošina.",
        "seo": {
          "title": "Profesionālās atbildības apdrošināšana — kam tā nepieciešama",
          "description": "Profesionālā atbildība sedz zaudējumus no kļūdas pakalpojumā. Kam tā vajadzīga, ko sedz un kā izvēlēties limitu un pašrisku."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Ja jūsu uzņēmums pārdod zināšanas, nevis preces, tad lielākais risks nav ugunsgrēks noliktavā, bet gan kļūda dokumentā. Nepareizs aprēķins, neiesniegta atskaite vai kļūdaina konsultācija var radīt klientam zaudējumus, kas daudzkārt pārsniedz pakalpojuma cenu."
          },
          {
            "type": "heading",
            "text": "Kam tā ir aktuāla"
          },
          {
            "type": "list",
            "items": [
              "Grāmatvedības un finanšu pakalpojumu sniedzējiem",
              "Arhitektiem, projektētājiem un būvuzraugiem",
              "IT izstrādes un konsultāciju uzņēmumiem",
              "Juridisko pakalpojumu sniedzējiem",
              "Mārketinga un tulkošanas pakalpojumu sniedzējiem"
            ]
          },
          {
            "type": "heading",
            "text": "Ko polise sedz"
          },
          {
            "type": "paragraph",
            "text": "Polise atlīdzina klienta zaudējumus, kas radušies jūsu profesionālas kļūdas, nolaidības vai bezdarbības dēļ. Papildus tā sedz juridisko aizstāvību, kas bieži ir lielākā izdevumu daļa, jo strīdi par pakalpojuma kvalitāti mēdz ievilkties."
          },
          {
            "type": "heading",
            "text": "Retroaktīvais periods"
          },
          {
            "type": "paragraph",
            "text": "Profesionālās atbildības polisēs būtiska ir laika dimensija. Kļūda var tikt atklāta pēc gada vai diviem. Tāpēc svarīgi ir divi nosacījumi: retroaktīvais periods, kas sedz pirms polises veiktos darbus, un pieteikšanas periods pēc polises beigām."
          },
          {
            "type": "callout",
            "title": "Nepārtrauciet segumu",
            "text": "Ja pārtraucat polisi, pazūd arī segums iepriekš veiktajiem darbiem. Tāpēc pakalpojumu uzņēmumiem polisi parasti tur spēkā vēl vairākus gadus pēc darbības izbeigšanas attiecīgajā jomā."
          },
          {
            "type": "heading",
            "text": "Kas netiek segts"
          },
          {
            "type": "list",
            "items": [
              "Apzināta maldināšana un krāpšana",
              "Līgumsodi un garantijas saistību izpilde",
              "Peļņas atmaksa par nekvalitatīvi sniegtu pakalpojumu",
              "Darbi, kas nav norādīti polisē kā apdrošinātā darbība"
            ]
          },
          {
            "type": "heading",
            "text": "Cik tas izmaksā"
          },
          {
            "type": "paragraph",
            "text": "Cena atkarīga no nozares, apgrozījuma un limita. Nelielam grāmatvedības birojam polise ar 100 000 eiro limitu bieži izmaksā 400–900 eiro gadā. Projektēšanā, kur iespējamie zaudējumi ir lielāki, prēmijas ir augstākas."
          },
          {
            "type": "paragraph",
            "text": "Norādiet pieteikumā savu darbības jomu un lielākā projekta apjomu — sagatavosim piedāvājumu ar atbilstošu limitu un retroaktīvo periodu."
          }
        ]
      },
      "udens-noplude-dzivokli": {
        "title": "Ūdens noplūde dzīvoklī — kas maksā par bojājumiem",
        "category": "majoklis",
        "related_product": "majokla-apdrosinasana",
        "author": "Andris Ozols, apdrošināšanas brokeris",
        "published_at": "2026-03-04",
        "tags": [
          "dzīvoklis",
          "ūdens noplūde",
          "atbildība"
        ],
        "excerpt": "Applūdis dzīvoklis ir biežākais apdrošināšanas gadījums daudzdzīvokļu mājās. Skaidrojam, kā noteikt atbildīgo un ko darīt pirmajās stundās.",
        "seo": {
          "title": "Ūdens noplūde dzīvoklī — kas atbild un kā saņemt atlīdzību",
          "description": "Kas maksā, ja dzīvoklī noplūdis ūdens vai ūdens nācis no kaimiņa? Rīcības soļi, atbildības sadalījums un padomi atlīdzības saņemšanai."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Ūdens noplūde ir gadījums, ar ko saskaras gandrīz katrs daudzdzīvokļu mājas iedzīvotājs — vai nu kā cietušais, vai kā vainīgais. Zaudējumi reti ir dramatiski lieli, bet 2 000–5 000 eiro par kaimiņa remontu ir pilnīgi reāla summa."
          },
          {
            "type": "heading",
            "text": "Pirmie soļi"
          },
          {
            "type": "list",
            "items": [
              "Aizveriet ūdens padevi un, ja nepieciešams, atslēdziet elektrību",
              "Nofotografējiet bojājumus, kamēr ūdens vēl redzams",
              "Informējiet apsaimniekotāju, lai fiksētu noplūdes vietu",
              "Ziņojiet apdrošinātājam un neveiciet remontu pirms apsekošanas",
              "Saglabājiet bojātās lietas, līdz apdrošinātājs tās apskatījis"
            ]
          },
          {
            "type": "heading",
            "text": "Kā nosaka, kurš atbild"
          },
          {
            "type": "paragraph",
            "text": "Atbildība atkarīga no tā, kur atradusies noplūdes vieta. Ja bojājums radies dzīvokļa iekšējos tīklos, atbild dzīvokļa īpašnieks. Ja plīsusi koplietošanas caurule vai tekošs jumts, atbildība parasti ir apsaimniekotājam. Šī iemesla dēļ svarīgi, lai noplūdes vietu fiksē apsaimniekotāja pārstāvis, nevis tikai iesaistītie kaimiņi."
          },
          {
            "type": "heading",
            "text": "Kāpēc atbildības segums ir svarīgākais"
          },
          {
            "type": "paragraph",
            "text": "Dzīvokļa polisē visvērtīgākā daļa bieži nav apdares segums, bet gan civiltiesiskā atbildība. Ja jūsu dēļ applūdis kaimiņa dzīvoklis, šī daļa atlīdzina viņa remontu. Praksē 5 000–10 000 eiro limits nosedz lielāko daļu gadījumu, bet jaunos projektos ar dārgu apdari ieteicams vairāk."
          },
          {
            "type": "callout",
            "title": "Ja ūdens nāk no augšas",
            "text": "Nav jāgaida, kamēr kaimiņš atzīs vainu. Sava polise atlīdzina bojājumus jums, un pēc tam apdrošinātājs pats vēršas pret vainīgo pusi."
          },
          {
            "type": "heading",
            "text": "Kā samazināt risku"
          },
          {
            "type": "list",
            "items": [
              "Nomainiet elastīgās ūdens pievadu šļūtenes reizi 5–7 gados",
              "Uzstādiet ūdens noplūdes sensorus zem izlietnes un veļas mašīnas",
              "Aizverot ūdens padevi, dodoties ilgākā ceļojumā",
              "Pārbaudiet boilera stāvokli un drošības vārstu"
            ]
          },
          {
            "type": "paragraph",
            "text": "Dzīvokļa polise ir viena no lētākajām — bieži 5–10 eiro mēnesī. Aizpildiet pieteikumu, un sagatavosim piedāvājumu ar atbilstošiem atbildības limitiem."
          }
        ]
      },
      "uznemuma-apdrosinasana-ar-ko-sakt": {
        "title": "Uzņēmuma apdrošināšana — ar ko sākt",
        "category": "uznemumiem",
        "related_product": "uznemumu-apdrosinasana",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-07-01",
        "tags": [
          "uzņēmumiem",
          "riski",
          "budžets"
        ],
        "excerpt": "Ne visus riskus vajag apdrošināt uzreiz. Piedāvājam kārtību, kādā mazam un vidējam uzņēmumam veidot apdrošināšanas segumu ar ierobežotu budžetu.",
        "seo": {
          "title": "Uzņēmuma apdrošināšana — no kā sākt un kā plānot budžetu",
          "description": "Kā mazam uzņēmumam sākt apdrošināšanu: risku novērtējums, prioritātes, kompleksais segums un biežākās kļūdas polišu izvēlē."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Uzņēmumu apdrošināšanā visbiežākā kļūda nav pārmaksa, bet gan nesegts risks, par kuru neviens nav padomājis. Tāpēc sākt vajadzētu nevis ar cenu, bet ar jautājumu: kas notiktu ar uzņēmumu, ja rīt kaut kas apstātos."
          },
          {
            "type": "heading",
            "text": "Solis pirmais — uzskaitiet, no kā atkarīga darbība"
          },
          {
            "type": "list",
            "items": [
              "Telpas, kurās strādājat, un to apdare",
              "Iekārtas un tehnika, bez kuras darbs nav iespējams",
              "Preču krājumi un materiāli",
              "Darbinieki un viņu zināšanas",
              "Klientu dati un informācijas sistēmas"
            ]
          },
          {
            "type": "heading",
            "text": "Solis otrais — sakārtojiet riskus pēc smaguma"
          },
          {
            "type": "paragraph",
            "text": "Apdrošināšana ir domāta notikumiem, ko uzņēmums nespētu izturēt no saviem līdzekļiem. Bojāts monitors ir izdevums, ko var samaksāt uzreiz. Ugunsgrēks noliktavā vai prasība no klienta par 50 000 eiro ir cita kategorija. Sāciet ar otro."
          },
          {
            "type": "heading",
            "text": "Solis trešais — prioritātes ierobežotam budžetam"
          },
          {
            "type": "list",
            "items": [
              "Civiltiesiskā atbildība — visbiežāk lielākais neparedzamais risks",
              "Īpašums un iekārtas — ja tās ir darbības pamatā",
              "Darbības pārtraukums — ja apstāšanās nozīmē ienākumu zudumu",
              "Darbinieku veselība un nelaimes gadījumi — noturēšanas instruments",
              "Kravu vai transporta riski — ja loģistika ir daļa no darbības"
            ]
          },
          {
            "type": "callout",
            "title": "Kompleksais segums parasti ir lētāks",
            "text": "Apvienojot vairākas polises vienā līgumā, apdrošinātāji bieži piedāvā atlaidi, un jums ir viens atjaunošanas datums, viens rēķins un mazāk pārklāšanās starp polisēm."
          },
          {
            "type": "heading",
            "text": "Ko sagatavot piedāvājumam"
          },
          {
            "type": "paragraph",
            "text": "Lai saņemtu reālu cenu, nepieciešams darbības apraksts, gada apgrozījums, darbinieku skaits un apdrošināmā īpašuma saraksts ar aptuvenām vērtībām. Ja iepriekš ir bijušas atlīdzības, tās arī jāmin — slēpšana vēlāk var kļūt par pamatu atteikumam."
          },
          {
            "type": "heading",
            "text": "Biežākās kļūdas"
          },
          {
            "type": "list",
            "items": [
              "Apdrošina tikai to, ko prasa banka vai iznomātājs",
              "Krājumu summu norāda pēc vidējā atlikuma, lai gan sezonā tas dubultojas",
              "Neatjauno summas pēc jaunu iekārtu iegādes",
              "Nepārbauda, vai nomas līgums prasa konkrētu segumu"
            ]
          },
          {
            "type": "paragraph",
            "text": "Aizpildiet pieteikumu, un konsultants kopā ar jums izies cauri riskiem, pirms sagatavot piedāvājumu."
          }
        ]
      },
      "veselibas-apdrosinasana-darbiniekiem": {
        "title": "Veselības apdrošināšana darbiniekiem — ar ko sākt",
        "category": "veseliba",
        "related_product": "darbinieku-apdrosinasana",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-05-13",
        "tags": [
          "darbinieki",
          "veselība",
          "uzņēmumiem"
        ],
        "excerpt": "Veselības polise ir viens no pieprasītākajiem darbinieku labumiem. Skaidrojam, kā izvēlēties programmu, ko ņemt vērā par nodokļiem un cik tas izmaksā.",
        "seo": {
          "title": "Veselības apdrošināšana darbiniekiem — programmas un izmaksas",
          "description": "Kā uzņēmumam izvēlēties darbinieku veselības apdrošināšanu: programmas apjoms, nodokļu atvieglojumi, izmaksas uz darbinieku un biežākās kļūdas."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Darba tirgū veselības apdrošināšana no papildu bonusa ir kļuvusi par pašsaprotamu daļu no atalgojuma paketes. Daudziem kandidātiem tas ir jautājums, ko uzdod jau pirmajā sarunā, tāpēc uzņēmumiem ir vērts saprast, ko tieši viņi piedāvā."
          },
          {
            "type": "heading",
            "text": "Kā izvēlēties programmas apjomu"
          },
          {
            "type": "paragraph",
            "text": "Programmas atšķiras pēc gada limitiem un iekļautajiem pakalpojumiem. Pamata programma sedz ģimenes ārstu, speciālistus un izmeklējumus. Plašākas programmas pievieno zobārstniecību, fizikālo terapiju, medikamentus un plānveida operācijas."
          },
          {
            "type": "list",
            "items": [
              "Pamata programma — konsultācijas un diagnostika",
              "Standarta programma — papildus zobārstniecība un terapija",
              "Plaša programma — medikamenti, operācijas, optika",
              "Papildinājumi — kritiskās slimības, sporta kompensācija"
            ]
          },
          {
            "type": "heading",
            "text": "Nodokļu puse"
          },
          {
            "type": "paragraph",
            "text": "Darba devēja iemaksas darbinieku veselības apdrošināšanā noteiktā apmērā gadā uz vienu darbinieku netiek apliktas ar algas nodokļiem, ja izpildīti likumā noteiktie nosacījumi — tostarp polises pieejamība visiem darbiniekiem un minimālais līguma termiņš. Aktuālo limitu ir vērts pārbaudīt katru gadu, jo tas mainās."
          },
          {
            "type": "callout",
            "title": "Vienlīdzība ir nosacījums",
            "text": "Ja vēlaties izmantot nodokļu atvieglojumu, polisei jābūt pieejamai visiem darbiniekiem vienādos nosacījumos. Atšķirīgas programmas dažādiem amatiem ir iespējamas, bet dalījumam jābūt pamatotam un dokumentētam."
          },
          {
            "type": "heading",
            "text": "Cik tas izmaksā"
          },
          {
            "type": "paragraph",
            "text": "Uz vienu darbinieku pamata programma parasti izmaksā 220–360 eiro gadā, bet programma ar zobārstniecību — 300–520 eiro. Cena samazinās, palielinoties grupas lielumam, jo riski izlīdzinās. Vairums apdrošinātāju grupas nosacījumus piemēro no pieciem darbiniekiem."
          },
          {
            "type": "heading",
            "text": "Biežākās kļūdas"
          },
          {
            "type": "list",
            "items": [
              "Programma izvēlēta pēc cenas, neuzzinot, kuras klīnikas ir pieejamas",
              "Nav pārbaudīti gada limiti atsevišķiem pakalpojumiem",
              "Darbinieki nav informēti, kā polisi izmantot, tāpēc tā paliek neizmantota",
              "Aizmirsts par komandējumiem, kuriem vajadzīga ceļojumu polise"
            ]
          },
          {
            "type": "paragraph",
            "text": "Pieteikumā norādiet darbinieku skaitu un vēlamo budžetu — sagatavosim piedāvājumu, ko varēsiet parādīt vadībai."
          }
        ]
      },
      "veselibas-polise-ko-tiesi-sedz": {
        "title": "Veselības polise — ko tā patiesībā sedz",
        "category": "veseliba",
        "related_product": "veselibas-apdrosinasana",
        "author": "Marta Kalniņa, uzņēmumu klientu brokere",
        "published_at": "2026-05-27",
        "tags": [
          "veselība",
          "segums",
          "limiti"
        ],
        "excerpt": "Veselības apdrošināšana nav neierobežota piekļuve medicīnai. Skaidrojam limitu sistēmu, līdzmaksājumus un to, kas paliek ārpus seguma.",
        "seo": {
          "title": "Ko sedz veselības apdrošināšana — limiti un līdzmaksājumi",
          "description": "Veselības polises segums, gada limiti, līdzmaksājumi un izņēmumi. Uzziniet, kā programma darbojas praksē un ko pārbaudīt pirms iegādes."
        },
        "body": [
          {
            "type": "paragraph",
            "text": "Veselības apdrošināšana darbojas pēc limitu principa: katram pakalpojumu veidam polisē ir noteikta summa gadā. Tas nozīmē, ka polise nav neierobežota pieeja medicīnai, bet gan budžets, ko varat izmantot noteiktās robežās."
          },
          {
            "type": "heading",
            "text": "Kā darbojas gada limiti"
          },
          {
            "type": "paragraph",
            "text": "Piemēram, programmā var būt 400 eiro ambulatorajiem pakalpojumiem, 150 eiro zobārstniecībai un 100 eiro medikamentiem. Kad limits izsmelts, pārējo apmaksājat pats. Tāpēc, izvēloties programmu, cena bez limitiem neko neizsaka."
          },
          {
            "type": "heading",
            "text": "Līdzmaksājums"
          },
          {
            "type": "paragraph",
            "text": "Daudzās programmās par katru vizīti pacients maksā daļu — parasti 10–30 %. Tas samazina polises cenu un ierobežo nevajadzīgus apmeklējumus. Pārbaudot piedāvājumu, ir vērts saprast, cik liels būs jūsu maksājums par tipisku speciālista vizīti."
          },
          {
            "type": "heading",
            "text": "Ko sedz standarta programma"
          },
          {
            "type": "list",
            "items": [
              "Ģimenes ārsta un speciālistu konsultācijas maksas klīnikās",
              "Laboratoriskie izmeklējumi un analīzes",
              "Ultrasonogrāfija, rentgens un citi instrumentālie izmeklējumi",
              "Fizikālā terapija un rehabilitācija limita ietvaros",
              "Profilaktiskā zobu higiēna un plombēšana, ja iekļauta"
            ]
          },
          {
            "type": "heading",
            "text": "Kas netiek segts"
          },
          {
            "type": "list",
            "items": [
              "Estētiskās procedūras un plastiskā ķirurģija",
              "Ārstēšanās ārzemēs — tam nepieciešama ceļojumu polise",
              "Hronisku slimību ārstēšana, ja diagnoze bijusi pirms polises",
              "Alternatīvā medicīna ārpus programmas saraksta",
              "Neauglības ārstēšana lielākajā daļā programmu"
            ]
          },
          {
            "type": "callout",
            "title": "Pārbaudiet klīniku sarakstu",
            "text": "Segums attiecas uz apdrošinātāja sadarbības iestādēm. Ja jums svarīgs konkrēts ārsts vai klīnika tuvu mājām, to vērts pārbaudīt pirms polises izvēles — cenas atšķirība bieži ir mazāka nekā ērtības ieguvums."
          },
          {
            "type": "heading",
            "text": "Nogaidīšanas periodi"
          },
          {
            "type": "paragraph",
            "text": "Daļai pakalpojumu, piemēram, zobārstniecībai vai plānveida operācijām, ir nogaidīšanas periods no viena līdz trim mēnešiem. Tas nozīmē, ka pirmajos mēnešos šos pakalpojumus izmantot nevar. Par to ir vērts zināt, ja polisi iegādājaties konkrētas vajadzības dēļ."
          },
          {
            "type": "paragraph",
            "text": "Aizpildiet pieteikumu un norādiet, kas jums ir vissvarīgākais — piedāvāsim programmas, kur tieši šie limiti ir pietiekami."
          }
        ]
      }
    },
    "ui": {
      "skip_to_content": "Pāriet pie satura",
      "optional": "nav obligāts",
      "locales": {
        "lv": "Latviešu",
        "en": "English",
        "ru": "Русский"
      },
      "locale_switcher": {
        "label": "Valoda"
      },
      "nav": {
        "main": "Galvenā navigācija",
        "mobile": "Mobilā navigācija",
        "open": "Atvērt izvēlni",
        "close": "Aizvērt izvēlni",
        "private": "Privātpersonām",
        "business": "Uzņēmumiem",
        "blog": "Blogs",
        "contacts": "Kontakti",
        "financing": "Finansējums",
        "apply": "Pieteikties"
      },
      "logo": {
        "home": "%{brand} — sākumlapa",
        "descriptor": "apdrošināšana"
      },
      "footer": {
        "private": "Privātpersonām",
        "business": "Uzņēmumiem",
        "blog": "Blogs",
        "legal": "Juridiska informācija",
        "copyright": "© %{year} %{name}. Visas tiesības aizsargātas.",
        "disclaimer": "Pilnvaru apjoms — sadarbība ar Balcia Insurance. Apdrošināšanas līgums tiek noslēgts ar apdrošināšanas sabiedrību.",
        "privacy": "Privātuma politika",
        "cookies": "Sīkdatņu politika",
        "terms": "Lietošanas noteikumi"
      },
      "cta": {
        "apply": "Pieteikties",
        "learn_more": "Uzzināt vairāk",
        "get_offer": "Saņemt piedāvājumu",
        "all_posts": "Visi raksti",
        "title": "Saņemiet apdrošināšanas piedāvājumu",
        "description": "Aizpildiet pieteikumu dažās minūtēs, un konsultants sagatavos apdrošināšanas piedāvājumu. Konsultācija ir bez maksas.",
        "call": "Zvanīt %{phone}"
      },
      "home": {
        "all_posts": "Visi raksti",
        "apply": "Pieteikties",
        "learn_more": "Uzzināt vairāk",
        "step": "Solis %{n}."
      },
      "product": {
        "benefits_title": "Ko dod %{name} apdrošināšana",
        "coverage_title": "Kas ir un kas nav segts",
        "covered": "Parasti ir segts",
        "not_covered": "Parasti nav segts",
        "coverage_note": "Precīzu segumu nosaka konkrētā apdrošinātāja polises noteikumi, ko saņemsiet pirms iegādes.",
        "pricing_title": "Cik tas maksā",
        "price_factors": "Kas ietekmē cenu",
        "faq_title": "Biežākie jautājumi",
        "related": "Bieži izvēlas arī",
        "cta_title": "Saņemiet %{name} piedāvājumu",
        "get_offer": "Saņemt piedāvājumu"
      },
      "blog": {
        "title": "Blogs par apdrošināšanu",
        "subtitle": "Skaidrojumi un padomi, kas palīdz izvēlēties pareizo segumu un nemaksāt par lieko.",
        "all_posts": "Visi raksti",
        "categories": "Bloga kategorijas",
        "empty": "Šajā kategorijā vēl nav rakstu. Apskatiet",
        "empty_link": "visus rakstus",
        "reading_time": "%{count} min lasīšana",
        "article": "Raksts",
        "topics": "Tēmas",
        "related_offer_title": "Vēlaties %{name} piedāvājumu?",
        "about_product": "Par %{name}",
        "get_offer": "Saņemt piedāvājumu",
        "disclaimer": "Raksts ir informatīvs un neaizstāj apdrošināšanas līguma noteikumus. Jautājumu gadījumā %{link}.",
        "contact_us": "sazinieties ar mums",
        "related_posts": "Citi raksti šajā kategorijā"
      },
      "static": {
        "updated": "Atjaunināts:"
      },
      "not_found": {
        "title": "Lapa nav atrasta",
        "body": "Iespējams, saite ir novecojusi vai adresē ir kļūda. Sāciet no sākumlapas vai aizpildiet pieteikumu — mēs sazināsimies ar jums.",
        "home": "Uz sākumlapu",
        "apply": "Pieteikties apdrošināšanai",
        "or_call": "Vai zvaniet:"
      },
      "error": {
        "title": "Neizdevās parādīt šo lapu",
        "body": "Kļūda ir mūsu pusē. Pārlādējiet lapu vai sazinieties ar mums — pieteikumu varam pieņemt arī pa telefonu.",
        "reload": "Pārlādēt lapu",
        "contacts": "Kontakti"
      },
      "application": {
        "title": "Pieteikums apdrošināšanas piedāvājumam",
        "subtitle": "Aizpildīšana aizņem apmēram 3 minūtes. Pieteikums nav saistošs.",
        "hero_title": "Pieteikties tagad",
        "how_we_work": "Kā mēs strādājam",
        "need_help": "Vajadzīga palīdzība ar aizpildīšanu?",
        "disclaimer": "Nosūtot pieteikumu, jūs nepērkat polisi — vispirms saņemsiet piedāvājumu izvērtēšanai.",
        "success_title": "Pieteikums ir saņemts",
        "success_body": "Konsultants izvērtēs jūsu vajadzības un sazināsies vienas darba dienas laikā — pa telefonu vai rakstot uz %{email}.",
        "reference": "Pieteikuma numurs:",
        "home": "Uz sākumlapu",
        "read_blog": "Lasīt blogu",
        "next": "Tālāk",
        "back": "Atpakaļ",
        "submit": "Saņemt apdrošināšanas piedāvājumu",
        "submit_hero": "Saņemt piedāvājumu",
        "submitting": "Nosūta…",
        "call_also": "Varat arī zvanīt: %{phone}.",
        "submit_error": "Neizdevās nosūtīt pieteikumu",
        "step_of": "%{current}. solis no %{total}",
        "step_aria": "Pieteikuma solis %{current} no %{total}",
        "validation_error": "Pieteikumā ir kļūdas",
        "rate_limit": "Pārāk daudz pieprasījumu. Lūdzu, mēģiniet vēlāk vai zvaniet mums.",
        "server_error": "Neizdevās sazināties ar serveri. Lūdzu, mēģiniet vēlreiz.",
        "trust": [
          "Sagatavojam apdrošināšanas piedāvājumu",
          "Konsultācija un pieteikuma sagatavošana bez maksas",
          "Atbildam vienas darba dienas laikā",
          "Datus izmantojam tikai piedāvājuma sagatavošanai"
        ],
        "steps": {
          "applicant": "Pieteicēja veids",
          "insurance": "Apdrošināšanas veids",
          "details": "Kontaktinformācija",
          "object": "Apdrošināšanai specifiska",
          "extra": "Papildu informācija"
        },
        "applicant": {
          "title": "Kas piesakās apdrošināšanai?",
          "description": "Tas nosaka, kādu informāciju jautāsim nākamajos soļos.",
          "legend": "Pieteicēja veids",
          "individual_title": "Fiziska persona",
          "individual_description": "Auto, mājoklis, ceļojumi, veselība un citi personīgie riski.",
          "company_title": "Juridiska persona",
          "company_description": "Uzņēmuma īpašums, atbildība, darbinieki un kravas."
        },
        "insurance": {
          "title": "Ko vēlaties apdrošināt?",
          "description": "Rādām tikai tos veidus, kas atbilst jūsu izvēlētajam pieteicēja tipam. Ja neatrodat piemērotu, izvēlieties “Cits”.",
          "label": "Apdrošināšanas veids",
          "search": "Meklēt apdrošināšanas veidu…",
          "selected": "Izvēlēts: %{name}. Nākamajā “Apdrošināšanai specifiskā” solī pajautāsim tikai to, kas nepieciešams piedāvājuma sagatavošanai."
        },
        "details": {
          "individual_title": "Jūsu kontaktinformācija",
          "company_title": "Uzņēmuma informācija",
          "description": "Šos datus izmantojam tikai piedāvājuma sagatavošanai un saziņai.",
          "first_name": "Vārds",
          "last_name": "Uzvārds",
          "personal_code": "Personas kods",
          "personal_code_hint": "Nepieciešams precīzai apdrošināšanas piedāvājuma sagatavošanai.",
          "personal_code_placeholder": "123456-12345",
          "city": "Pilsēta",
          "company_name": "Uzņēmuma nosaukums",
          "registration_number": "Reģistrācijas numurs",
          "registration_placeholder": "40003000000",
          "contact_person": "Kontaktpersona",
          "employee_count": "Darbinieku skaits",
          "industry": "Nozare",
          "industry_placeholder": "Piemēram, būvniecība vai tirdzniecība",
          "phone": "Telefons",
          "phone_placeholder": "20000000",
          "email": "E-pasts",
          "email_placeholder": "vards@piemers.lv"
        },
        "object": {
          "title": "Apdrošināšanai specifiska informācija",
          "description_named": "Šie lauki attiecas uz %{name}. Ja kaut ko nezināt precīzi, norādiet aptuveni — konsultants to precizēs.",
          "description": "Ja kaut ko nezināt precīzi, norādiet aptuveni — konsultants to precizēs."
        },
        "extra": {
          "title": "Papildu informācija",
          "description": "Pastāstiet, ja ir kaut kas īpašs — piemēram, esošā polise, vēlamā pašriska summa vai termiņš.",
          "message": "Komentāri",
          "message_placeholder": "Piemēram: pašreizējā polise beidzas 1. martā, vēlos zemāku pašrisku.",
          "consent_before": "Piekrītu, ka mani dati tiek apstrādāti apdrošināšanas piedāvājuma sagatavošanai saskaņā ar ",
          "consent_link": "privātuma politiku",
          "consent_after": ".",
          "marketing": "Vēlos saņemt informāciju par piedāvājumiem un polišu atjaunošanas termiņiem."
        }
      },
      "validation": {
        "applicant_type": "Izvēlieties pieteicēja veidu",
        "insurance_type": "Izvēlieties apdrošināšanas veidu",
        "insurance_type_available": "Izvēlieties pieejamu apdrošināšanas veidu",
        "first_name": "Norādiet vārdu",
        "first_name_short": "Vārdam jābūt vismaz 2 rakstzīmes garam",
        "last_name": "Norādiet uzvārdu",
        "last_name_short": "Uzvārdam jābūt vismaz 2 rakstzīmes garam",
        "personal_code": "Pārbaudiet personas kodu",
        "city_short": "Pilsētas nosaukumam jābūt vismaz 2 rakstzīmes garam",
        "company_name": "Norādiet uzņēmuma nosaukumu",
        "company_name_short": "Nosaukumam jābūt vismaz 2 rakstzīmes garam",
        "registration_number": "Norādiet reģistrācijas numuru",
        "contact_person": "Norādiet kontaktpersonu",
        "contact_person_short": "Kontaktpersonai jābūt vismaz 2 rakstzīmes garai",
        "employee_count": "Darbinieku skaitam jābūt vismaz 1",
        "phone": "Norādiet telefona numuru",
        "phone_invalid": "Pārbaudiet telefona numuru (piemēram, +37120000000)",
        "email": "Norādiet e-pasta adresi",
        "email_invalid": "Pārbaudiet e-pasta adresi",
        "field_required": "Norādiet: %{label}",
        "number": "Norādiet skaitli",
        "consent": "Nepieciešama piekrišana datu apstrādei"
      },
      "select": {
        "placeholder": "Izvēlieties…",
        "search": "Meklēt…",
        "no_results": "Nav rezultātu",
        "search_field": "Meklēt: %{label}…"
      },
      "phone": {
        "country_code": "Valsts kods",
        "countries": {
          "+371": "Latvija",
          "+372": "Igaunija",
          "+370": "Lietuva",
          "+358": "Somija",
          "+46": "Zviedrija",
          "+47": "Norvēģija",
          "+45": "Dānija",
          "+49": "Vācija",
          "+48": "Polija",
          "+7": "Krievija",
          "+1": "ASV",
          "+44": "Apvienotā Karaliste",
          "+33": "Francija",
          "+39": "Itālija",
          "+34": "Spānija"
        }
      },
      "breadcrumbs": {
        "location": "Atrašanās vieta"
      },
      "dates": {
        "locale": "lv-LV",
        "year_suffix": ". gada"
      }
    }
  }
}
